<template>
  <div id="el" class="flex-1 p-4 grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-4 self-start" style="min-width: 500px;">
    <div class="sm:col-span-full">
      <WmsTextInput
        name="estimateNo"
        caption="見積No"
        :disabled="true"
        v-model="order.estimateNo"
      />
    </div>

    <div class="sm:col-span-4">
      <WmsTextInput
        name="caseName"
        caption="案件名"
        v-model="order.caseName"
        :disabled="isDisabled || referenceMode"
      >
      </WmsTextInput>
    </div>

    <div class="sm:col-span-2" style="margin-top: auto">
      <PrimaryButton text="見積参照" class="w-40" @click="referenceEstimate">
      </PrimaryButton>
    </div>

    <div class="sm:col-span-full" v-tooltip="'【物件番号】要記載得意先：東急・アートアベニュー・三菱・セキスイ・ナイス・長谷工・大和地所・大京・野村不動産、 【チーム】要記載得意先：東急（住宅リース以外）'">
      <WmsTextInput
        name="clientOnbuildingName"
        caption="物件情報"
        v-model="order.buildingName"
        :multiline="true"
        :rows="3"
        :disabled="isDisabled || referenceMode"
      />
    </div>

    <div class="sm:col-span-full pt-4">
      <div class="flex">
        <div class="text-xs font-bold text-gray-700 my-auto">メモ</div>
        <PrimaryButton text="新規得意先" v-tooltip="'メモ欄に得意先情報を表示します'" size="xs" class="ml-5" @click="clientContents(mainData||orderData)" :disabled="isDisabled || referenceMode" :class="order.newClient?'':'bg-gray-300'"></PrimaryButton>
        <PrimaryButton text="既存得意先" v-tooltip="'メモ欄の得意先情報を削除します'" size="xs" class="ml-3" @click="deleteClientContents()" :disabled="isDisabled || referenceMode" :class="order.newClient?'bg-gray-300':''"></PrimaryButton>
      </div>
      <WmsTextInput
        name="orderMemo"
        :multiline="true"
        :rows="order.newClient ? 8 : 5"
        v-model="order.orderMemo"
        :disabled="isDisabled || referenceMode"
      />
    </div>

    <!-- 新規得意先の場合 -->
    <div v-if="order.newClient" class="sm:col-span-full">
      <div class="flex w-full">
        <div class="w-1/2">
          <OrderItemSelect
            name="orderSendingDate"
            caption="予定送付日"
            v-model="order.orderSendingDate"
            :multiSelect="false"
            :item="[{ value: '1', text: '20日' }, { value: '2', text: '変更あり' }]"
            :disabled="isDisabled || referenceMode"
          />
        </div>
        <div class="w-1/2 ml-3">
          <!-- 変更ありの場合 -->
          <WmsTextInput
            name="orderSendingDateMemo"
            caption="予定送付日 (変更ありの場合)"
            v-model="order.orderSendingDateMemo"
            :disabled="isDisabled || referenceMode"
            v-if="order.orderSendingDate&&order.orderSendingDate[0]=='2'"
            cl
          />
        </div>
      </div>
    </div>

    <!-- 新規得意先の場合 -->
    <div v-if="order.newClient" class="sm:col-span-full">
      <div class="flex w-full">
        <div class="w-1/2">
          <OrderItemSelect
            name="orderClosingDate"
            caption="締め日"
            v-model="order.orderClosingDate"
            :multiSelect="false"
            :item="[{ value: '1', text: '末日' }, { value: '2', text: '変更あり' }]"
            :disabled="isDisabled || referenceMode"
          />
        </div>
        <div class="w-1/2 ml-3">
          <!-- 変更ありの場合 -->
          <WmsTextInput
            name="orderClosingDateMemo"
            caption="締め日 (変更ありの場合)"
            v-model="order.orderClosingDateMemo"
            :disabled="isDisabled || referenceMode"
            v-if="order.orderClosingDate&&order.orderClosingDate[0]=='2'"
            cl
          />
        </div>
      </div>
    </div>

    <!-- 新規得意先の場合 -->
    <div v-if="order.newClient" class="sm:col-span-full">
      <div class="flex w-full">
        <div class="w-1/2">
          <OrderItemSelect
            name="orderBillingDate"
            caption="請求送付日"
            v-model="order.orderBillingDate"
            :multiSelect="false"
            :item="[{ value: '1', text: '末日' }, { value: '2', text: '変更あり' }]"
            :disabled="isDisabled || referenceMode"
          />
        </div>
        <div class="w-1/2 ml-3">
          <!-- 変更ありの場合 -->
          <WmsTextInput
            name="orderBillingDateMemo"
            caption="請求送付日 (変更ありの場合)"
            v-model="order.orderBillingDateMemo"
            :disabled="isDisabled || referenceMode"
            v-if="order.orderBillingDate&&order.orderBillingDate[0]=='2'"
            cl
          />
        </div>
      </div>
    </div>

    <!-- 新規得意先の場合 -->
    <div v-if="order.newClient" class="sm:col-span-full">
      <div class="flex w-full">
        <div class="w-1/2">
          <OrderItemSelect
            name="orderBillingName"
            caption="請求宛先名"
            v-model="order.orderBillingName"
            :multiSelect="false"
            :item="[{ value: '1', text: '変更なし' }, { value: '2', text: '変更あり' }]"
            :disabled="isDisabled || referenceMode"
          />
        </div>
        <div class="w-1/2 ml-3">
          <!-- 変更ありの場合 -->
          <WmsTextInput
            name="orderBillingNameMemo"
            caption="請求宛先名 (変更ありの場合)"
            v-model="order.orderBillingNameMemo"
            :disabled="isDisabled || referenceMode"
            v-if="order.orderBillingName&&order.orderBillingName[0]=='2'"
            cl
          />
        </div>
      </div>
    </div>

    <div v-if="!order.newClient" class="sm:col-span-full text-sm text-gray-700 border border-blue-700 rounded px-2 pt-1 pb-2 mt-5">
      <div class="text-blue-600 text-xs font-bold flex">ビルメンツ情報
        <div v-if="loading" class="pl-5 animate-pulse">データ取得中</div>
        <PrimaryButton text="再取得" size="xs" class="ml-auto" @click="getBillingData()"></PrimaryButton>
      </div>

      <div class="text-red-700 text-sm font-bold" v-if="!order.siteCode&&order.classification&&order.classification[0]!='1'">物件コードが取得できていません。ドロップダウンから物件を選択してください。<br>（該当の物件がない場合は「お客様会社名」を再度選択してください）</div>

      <!-- 物件名（新規以外） -->
      <div class="mt-3" v-if="order.classification&&order.classification[0]!='1'">
        <WmsSuggestInput
          name="sn"
          caption="物件名"
          :selectionItems="buildingListByClient"
          :displayField="['site1', 'site2']"
          :filter="{}"
          :clearable="true"
          v-model="order.siteName"
          :disabled="isDisabled || referenceMode"
          class="w-64 inline-block"
          @selected="siteSelected($event)"
          @blur="siteNameChanged()"
        />
        （物件コード： {{ order.siteCode }}）
      </div>
      <div v-if="order.siteName&&estimateData.buildingName&&order.siteName.trim()!=estimateData.buildingName.trim()" class="text-red-700 font-bold text-xs mt-1">物件名が合っているかご確認ください</div>

      <!-- 得意先名 -->
      <div class="mt-3 ml-3 font-bold text-xs" v-if="order.cc">{{ order.cn1 }} {{ order.cn2 }} （得意先コード： {{ order.cc }}）</div>
      <div v-if="order.cc&&order.cc!=order.clientCode" class="text-red-700 font-bold text-xs mt-1">得意先が合っているかご確認ください（違う場合は「お客様会社名」を再度選択してください）</div>
      <div v-else-if="order.cc&&order.clientName&&(order.cn1 + ' ' + order.cn2)!=order.clientName" class="text-red-700 font-bold text-xs mt-1">得意先が合っているかご確認ください（違う場合は「お客様会社名」を再度選択してください）</div>

      <div class="table border-collapse mt-5">
        <div class="table-row">
          <div class="table-cell p-2 font-bold text-gray-500">予定送付日</div>
          <div class="table-cell p-2" :class="order.sentDate=='20'?'':'text-red-700 font-bold'">{{ order.sentDate }}</div>
        </div>
        <div class="table-row">
          <div class="table-cell p-2 font-bold text-gray-500">締め日</div>
          <div class="table-cell p-2" :class="order.closingDate=='月末'?'':'text-red-700 font-bold'">{{ order.closingDate }}</div>
        </div>
        <div class="table-row">
          <div class="table-cell p-2 font-bold text-gray-500">請求送付日</div>
          <div class="table-cell p-2" :class="order.billingDate=='月末'?'':'text-red-700 font-bold'">{{ order.billingDate }}</div>
        </div>
        <div class="table-row">
          <div class="table-cell p-2 font-bold text-gray-500">請求宛先名</div>
          <div v-if="order.sentNames&&order.sentNames.length" class="table-cell p-2">
            <span v-if="order.sentNames.length>1" class="text-red-700">（{{ order.sentNames.length }}種類あります）</span>
            {{ order.sentNames.join(' 、 ') }}
          </div>

        </div>
      </div>
    </div>

    <div class="sm:col-span-full mt-5">
      <WmsTextInput
        name="orderSummary"
        caption="登録内容"
        :multiline="true"
        :rows="5"
        v-model="order.orderSummary"
        disabled="true"
        v-if="order.orderSummary"
      />
    </div>

    <div class="sm:col-span-2">
      <WmsDateInput
        name="contractDate"
        caption="契約日"
        v-model="order.contractDate"
        :required="true"
        :clearable="true"
        :error="!validateContractDate.result"
        :errorMessage="validateContractDate.message"
        @change="changeContractDate($event)"
        v-if="!isTaskRequestMode && !referenceMode"
      />

      <WmsTextInput
        name="contractDate"
        caption="契約日"
        :required="true"
        v-model="dispContractDate"
        :disabled="true"
        v-if="isTaskRequestMode || referenceMode"
      />
    </div>

    <div class="sm:col-span-2">
      <WmsDateInput
        name="contractEndDate"
        caption="契約終了日"
        v-model="order.contractEndDate"
        :required="true"
        :clearable="true"
        :error="!validateContractEndDate.result"
        :errorMessage="validateContractEndDate.message"
        @change="changeContractEndDate($event)"
        v-if="!isTaskRequestMode && !referenceMode"
      />

      <WmsTextInput
        name="contractEndDate"
        caption="契約終了日"
        v-model="dispContractEndDate"
        :disabled="true"
        v-if="isTaskRequestMode || referenceMode"
      />
    </div>

    <div class="sm:col-span-full" ref="startMemo">
      <div class="text-xs text-gray-700 font-bold">初回作業日（スポットは必須です。未入力の場合「初回作業日連絡」サブタスクを完了できません。）</div>
      <div class="text-xs text-red-700 font-bold">＊サブタスク画面からもこの項目は入力できます<span v-if="isDisabled" class="pl-5 text-red-500">（自動保存します）</span><span v-if="updateStartMemo" class="pl-10 text-red-500">保存中..</span></div>
      <textarea
        :rows="3"
        class="text-gray-700 focus:ring-indigo-500 focus:border-indigo-500 w-full sm:text-sm border-gray-300 rounded field"
        :class="startMemoBgColor&&!order.startMemo?'bg-red-200 animate-pulse border-red-500':''"
        :disabled="referenceMode"
        v-model="order.startMemo"
        @change="changeStartMemo()"
      />
    </div>

    <div class="mt-3 sm:col-span-full">
      <OrderItemSelect
        name="classification"
        caption="区分"
        v-model="order.classification"
        :required="true"
        :error="!validateClassification.result"
        :errorMessage="validateClassification.message"
        :multiSelect="false"
        :item="selectItemClassification"
        @change="changeClassification($event)"
        :disabled="isDisabled || referenceMode"
      />
    </div>

    <div class="mt-3 sm:col-span-full">
      <OrderItemSelect
        name="monthlyFeeFlag"
        caption="均等請求有無"
        v-model="order.monthlyFeeFlag"
        :multiSelect="false"
        :item="selectItemMonthlyFeeFlag"
        :disabled="true"
      />
    </div>

    <!-- 契約詳細情報を登録（日常清掃・管理員業務・固定清掃のあるラウンドプラスがあり、サブタスクに「契約詳細登録申請」があるとき）
         下の作業曜日・時間などの入力が、契約詳細入力画面（AkbsContractForm）の契約コードの初期値になる（変更処理の黄色い帯と同じ見た目） -->
    <div v-if="showContractDetail" class="sm:col-span-full flex items-center justify-between gap-3 border-2 border-yellow-500 rounded-md px-3 py-2 bg-yellow-50 mt-2">
      <div>
        <div class="text-sm font-bold text-yellow-800">契約詳細情報の登録が必要です</div>
        <div class="text-xs text-red-700 font-bold mt-1">AKBS稼働管理・清掃員のシフトに影響するため、契約詳細情報も申請してください。</div>
        <ol class="text-xs text-gray-700 font-bold mt-1 list-decimal list-inside">
          <li>{{ contractTargetNames.join('・') }}のメインタスクの情報を入力完了する{{ isTaskRequestMode || referenceMode ? '（保存する）' : '' }}</li>
          <li>「契約詳細を登録」を押して内容を確認し「申請」を押す</li>
          <li>自動でサブタスク（契約詳細登録申請）が完了</li>
        </ol>
      </div>
      <div class="text-right">
        <div class="text-xs text-gray-600 mb-1">申請の状況：<span class="font-bold" :class="order.contractDetailStatus ? 'text-indigo-700' : 'text-gray-700'">{{ order.contractDetailStatus || '未申請' }}</span></div>
        <PrimaryButton text="契約詳細を登録" size="sm" class="whitespace-nowrap" @click="toContractDetail()"></PrimaryButton>
      </div>
    </div>

    <div class="sm:col-span-full button-w-sm">
      <EstimationDetailsCategorySelect
        name="estimationDetailsCategory"
        caption="見積明細カテゴリー"
        v-model="order.estimationDetailsCategory"
        :disabled="true"
        :categoryName="order.categoryName"
        :categoryCode="order.estimationDetailsCategoryCode"
      />
    </div>

    <div v-for="(p, i) in property" :key="100 + i" class="sm:col-span-full" v-show="order[p] && order[p].length">
      <div class="sm:col-span-full"  v-if="order[p] && order[p].length" :class="['orderSpot', 'orderOthers'].includes(p) ? '':'border border-indigo-200'">
        <div v-for="(o, oI) in order[p]" v-bind:key="200 + oI" :class="o.file ? 'border border-indigo-200 mt-3':''">
          <div class="p-5">
            <InputGroupSubLabel
              :caption="o.name"
              id="sub-label"
              class="mt-4 sm:col-span-full"
            />

            <!-- RLSプラス 種別 -->
            <div class="sm:col-span-full" v-if="o.categoryCode=='2'">
              <OrderItemSelect
                name="estimationRoundPlusCategorySelect"
                v-model="o.estimationRoundPlusCategorySelect"
                :item="estimationRoundPlusCategorySelectItem"
                :disabled="true"
              />
            </div>

            <!-- 作業内容コード -->
            <div class="mt-osc" v-if="o.workCode && (o.categoryCode!='14' || (o.categoryCode == '14' && o.newData))">
              <div class="text-xs text-gray-600 font-bold">
                <label class="block text-xs font-bold text-gray-700">
                  作業内容コード
                </label>
                <div class="flex">
                  <div class="w-40 border border-gray-300 rounded h-8 p-2 mt-1" :class="(isDisabled || referenceMode)? 'cursor-not-allowed': 'bg-white cursor-pointer'" @click="openWorkCode(o)">
                    {{ o.workCode.code }}
                  </div>
                  <div v-if="o.workCode.code" class="my-auto text-gray-400 text-xs ml-3">
                    {{ o.workCode.category }} ⇒ {{ o.workCode.detail }}
                  </div>
                </div>
              </div>
            </div>

            <!-- 日常・管理・定期・特別の場合 -->
            <div v-if="['3', '4', '5', '14'].includes(o.categoryCode)" class="sm:col-span-full">
              <div v-for="(det, j) in o.details" :key="300 + j">
                <div v-if="det.content" class="sm:col-span-full mt-3" :class="{'mt-6': j > 0}">
                  <label
                    v-if="det.content.indexOf('調整費')==-1"
                    :name="p + 'Content'"
                    class="text-sm font-bold"
                  >
                    【{{det.content}}】
                  </label>
                </div>

                <!-- 特別清掃 -->
                <div class="mt-osc" v-if="o.categoryCode=='14'">
                  <div v-if="!o.newData" class="text-xs text-gray-600 font-bold">
                    <label v-if="det.workCode" class="block text-xs font-bold text-gray-700">
                      作業内容コード
                    </label>
                    <div v-if="det.workCode" class="flex">
                      <div class="w-40 border border-gray-300 rounded h-8 p-2 mt-1" :class="(isDisabled || referenceMode)? 'cursor-not-allowed': 'bg-white cursor-pointer'" @click="openWorkCode(det)">
                        {{ det.workCode.code }}
                      </div>
                      <div v-if="det.workCode.code" class="my-auto text-gray-400 text-xs ml-3">
                        {{ det.workCode.category }} ⇒ {{ det.workCode.detail }}
                      </div>
                    </div>
                  </div>

                  <!-- 特別清掃の作業項目（契約書に使用）調整費以外で表示 -->
                  <div v-if="det.content.indexOf('調整費')==-1" class="text-xs text-gray-600 font-bold mt-2">
                    <label
                      class="block text-xs font-bold text-gray-700"
                    >
                      作業項目 <span class="-top-0.5 ml-1 text-red-500"> * </span>
                    </label>
                    <div class="mt-1 flex relative">
                      <InputIcon v-if="!det.workItem" iconName="ExclamationCircle" :iconColor="'red'" message="作業項目は必須入力です。"/>
                      <form>
                        <select
                          name="specialCleanWorkItem"
                          caption="作業項目"
                          v-model="det.workItem"
                          :disabled="isDisabled || referenceMode"
                          class="focus:bg-yellow-100 focus:ring-indigo-500 focus:border-indigo-500 block border-transparent w-full text-xs drop border-gray-300 "
                          :class="[isDisabled || referenceMode ? 'cursor-not-allowed' : '']"
                        >
                          <option
                            v-for="workItem in workItemList"
                            :key='workItem.id'
                            :value="workItem.id"
                            class="bg-white">
                            {{ workItem.value }}
                          </option>
                        </select>
                      </form>
                    </div>
                  </div>
                </div>

                <!-- <div v-if="['3', '4'].includes(o.categoryCode)" class="mt-3 sm:col-span-full button-w-sm">
                  <OrderItemSelect
                    :name="p + 'Count2'"
                    caption="清掃希望回数"
                    v-model="det.count2"
                    :item="selectEstimationEverydayCountItemMonth(det.count2)"
                    :disabled="true"
                  />
                </div>

                <div v-if="['3', '4'].includes(o.categoryCode)&&det.specificTime" class="mt-3 sm:col-span-full">
                  <OrderItemSelect
                    :name="p + 'specificTime'"
                    caption="時間指定"
                    v-model="det.specificTime"
                    :item="selectItemCommissionFlag"
                    :disabled="true"
                  />
                </div> -->

                <!-- 定期清掃 見積りの数量2 -->
                <div v-else-if="det.dispCount || det.dispCount==''" class="sm:col-span-full mt-3">
                  <WmsTextInput
                    :name="p + 'Count'"
                    caption="清掃希望回数"
                    v-model="det.dispCount"
                    :disabled="true"
                  />
                </div>

                <!-- 日常・管理 -->
                <div v-if="['3', '4'].includes(o.categoryCode)" class="mt-3">
                  <WmsDateInput
                    :name="p + 'startDate'"
                    caption="開始日"
                    v-model="det.startDate"
                    :clearable="true"
                    v-if="!isTaskRequestMode && !referenceMode"
                  />

                  <WmsTextInput
                    :name="p + 'startDate'"
                    caption="開始日"
                    v-model="det.startDate"
                    :disabled="true"
                    v-if="isTaskRequestMode || referenceMode"
                  />

                  <OrderItemSelect
                    :name="p + 'Count2'"
                    caption="清掃希望回数"
                    v-model="det.count2"
                    :item="selectEstimationEverydayCountItemMonth(det.count2)"
                    :disabled="true"
                    class="mt-3 button-w-sm"
                  />

                  <OrderItemSelect
                    v-if="det.specificTime"
                    :name="p + 'specificTime'"
                    caption="時間指定"
                    v-model="det.specificTime"
                    :item="selectItemCommissionFlag"
                    :disabled="true"
                    class="mt-3"
                  />

                  <OrderItemSelect
                    v-if="det.holiday"
                    :name="p + 'holi'"
                    caption="祝日対応"
                    v-model="det.holiday"
                    :item="holiday"
                    :disabled="true"
                    class="mt-3"
                  />

                  <div class="mt-3 sm:col-span-full" v-if="det.newYearHolidays">
                    <div class="text-xs font-bold text-gray-700 mb-1">年末年始</div>
                    <div v-if="isMitsui" class="text-xs font-bold text-red-700 mb-1">＊三井不動産様は、12/30は出勤日です</div>
                    <div class="flex text-sm" v-if="det.newYearHolidays.length||isMitsui">
                      <div v-for="(n, nI) in [30, 31, 1, 2, 3]" :key="i+'n'+oI+'n'+nI"
                        style="width: 14%; margin-right: 1px;"
                        class="border border-gray-200 py-2 text-center cursor-not-allowed"
                        :class="det.newYearHolidays.includes(n)||(isMitsui&&n==30)?'bg-indigo-900 text-white font-bold':'bg-white text-gray-600'"
                      >
                        {{ n }}
                      </div>
                    </div>
                    <div v-else class="bg-gray-200 text-gray-700 text-sm py-1.5 px-3 rounded border border-gray-300 cursor-not-allowed">
                      なし
                    </div>
                  </div>
                </div>

                <!-- 定期・特別 -->
                <div v-else>
                  <div class="mt-3 sm:col-span-full" v-if="det.firstWorkYear || det.firstWorkYear == ''">
                    <WmsSuggestInput
                      :name="p + 'FirstWorkYear'"
                      caption="初回作業年"
                      :dynamic="false"
                      :incrementalSearch="false"
                      :selectionItems="selectItemYear"
                      displayField="text"
                      :filter="{}"
                      :clearable="true"
                      v-model="det.firstWorkYear"
                      :disabled="isDisabled || referenceMode"
                    />
                  </div>

                  <div class="mt-3 sm:col-span-full button-w-sm3" v-if="det.firstWorkMonth">
                    <OrderItemSelect
                      :name="p + 'FirstWorkMonth'"
                      caption="初回作業月"
                      v-model="det.firstWorkMonth"
                      :multiSelect="false"
                      :item="selectItemMonth"
                      :disabled="isDisabled || referenceMode"
                      @change="changeFirstWorkMonthDetails($event, j, o.details, o)"
                    />
                  </div>

                  <div class="sm:col-span-full mt-3 button-w-sm3" v-if="det.implementationMonth">
                    <OrderItemSelect
                      :name="p + 'ImplementationMonth'"
                      caption="実施月"
                      v-model="det.implementationMonth"
                      :item="selectItemMonth"
                      :disabled="isDisabled || referenceMode"
                    />
                  </div>

                  <div class="mt-3" v-if="det.unitPrice">
                    <WmsTextInput
                      :name="p + 'UnitPrice'"
                      caption="受注単価（税抜き）"
                      v-model="det.unitPrice"
                      :disabled="true"
                    />
                  </div>

                  <div class="mt-3" v-if="det.amount">
                    <WmsTextInput
                      :name="p + 'Amount'"
                      caption="受注総額（税抜き）"
                      v-model="det.amount"
                      :disabled="true"
                    />
                  </div>

                  <div v-if="o.categoryCode=='5'" class="grid grid-cols-6 gap-2">
                    <div class="mt-3 col-span-3">
                      <WmsSuggestInput
                        name="regularCleanTargetArea"
                        caption="対象箇所"
                        :dynamic="false"
                        :incrementalSearch="false"
                        :selectionItems="regularCleanTargetAreaSelectItem"
                        displayField="text"
                        :filter="{}"
                        :clearable="true"
                        v-model="det.area"
                        :disabled="isDisabled || referenceMode"
                      />
                    </div>

                    <div class="mt-3 col-span-3">
                      <WmsSuggestInput
                        name="regularCleanDescriptionWork"
                        caption="作業内容"
                        :dynamic="false"
                        :incrementalSearch="false"
                        :selectionItems="regularCleanDescriptionWorkSelectItem"
                        displayField="text"
                        :filter="{}"
                        :clearable="true"
                        v-model="det.workDetail"
                        :disabled="isDisabled || referenceMode"
                      />
                    </div>
                  </div>

                  <!-- <div v-if="o.categoryCode=='5'" class="mt-3 sm:col-span-1">
                    <OrderItemSelect
                      name="regularCleanCarpet"
                      caption="カーペット対象の場合はクリックして下さい"
                      v-model="det.carpet"
                      :item="selectItemCarpet"
                      :disabled="isDisabled || referenceMode"
                    />
                  </div> -->
                </div>

                <!-- 日常・管理の作業詳細（人数分） -->
                <div class="sm:col-span-full mt-3" v-if="det.remarks">
                  <div v-for="(remark, index) in det.remarks" v-bind:key="400 + index">
                    <div class="sm:col-span-full" :class="{'mt-6': index > 0}">
                      <label
                        name="idxLabel"
                        class="text-sm font-bold"
                      >
                        【{{index + 1}}】
                      </label>
                    </div>

                    <!-- 曜日ごとの形（契約詳細入力画面と同じ。1行＝1人。見積から作った受注はこの形。過去の受注は下の形のまま） -->
                    <div class="sm:col-span-full" v-if="isDaysRemark(remark)">
                      <div class="text-xs font-bold text-gray-700 mb-1">作業曜日・時間（曜日を押すと勤務あり／なし）</div>
                      <OrderRemarkDays :remark="remark" :disabled="isDisabled || referenceMode" @change="reload++" />
                    </div>
                    <!-- 新しい形 -->
                    <div class="sm:col-span-full" v-else-if="remark.weekDetail && typeof remark.weekDetail === 'object' && !Array.isArray(remark.weekDetail)">
                      <div class="text-xs font-bold text-gray-700 mb-1">作業曜日</div>
                      <div class="flex text-sm">
                        <div v-for="(w, wi) in selectItemWeek" :key="i+'w'+oI+'r'+index+'w'+wi"
                          style="width: 14%; margin-right: 1px;"
                          class="border border-gray-200 py-2 text-center"
                          :class="[remark.workDays.includes(w.value)?'bg-indigo-900 text-white font-bold':'bg-white text-gray-700', (isDisabled || referenceMode)?'cursor-not-allowed':'cursor-pointer']"
                          @click="clickWorkDays(w.value, remark)"
                        >
                          {{ w.text }}
                        </div>
                      </div>

                      <div v-if="remark.weekDetail">
                        <!-- 毎週OR第●週 -->
                        <div class="flex">
                          <div v-for="(w, wi) in selectItemWeek" :key="i+'w'+oI+'r2'+index+'wd'+wi" style="width: 14%; margin-right: 1px;">

                            <multiselect
                              v-if="!isDisabled"
                              v-model="remark.weekDetail[w.value]"
                              :options="weekDetailList"
                              :multiple="true"
                              :close-on-select="false"
                              :show-labels="false"
                              :searchable="false"
                              :allow-empty="true"
                              :hide-selected="true"
                              placeholder=""
                              class="multiselect"
                              :disabled="!remark.workDays.includes(w.value) || isDisabled || referenceMode"
                              @input="reload++"
                            >
                            </multiselect>
                            <!-- サブタスクでの表示（小さくてわからない） -->
                            <div v-else class="border border-gray-200 rounded text-center py-1 text-sm text-gray-600 bg-gray-50">
                              <div v-if="remark.weekDetail[w.value]" class="whitespace-pre-line">
                                {{ remark.weekDetail[w.value].join('\n') }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 以前の形 -->
                    <div v-else class="sm:col-span-full" >
                      <div class=" button-w-sm2">
                        <OrderItemSelect
                          name="remarkDays"
                          caption="作業曜日"
                          v-model="remark.workDays"
                          :item="selectItemWeek"
                          :disabled="isDisabled || referenceMode"
                        />
                      </div>
                      <div v-if="remark.weekDetail">
                        <OrderWeekDetailSelect
                          v-model="remark.weekDetail"
                          :selectedWeeks="remark.workDays"
                          :weekDetail="remark.weekDetail"
                          :idx="index+''+i"
                          :disabled="isDisabled || referenceMode"
                        />
                      </div>
                    </div>

                    <!-- 行に時間が1組の形（曜日ごとの形は曜日の中に時間がある） -->
                    <div class="flex mt-ec" v-if="!isDaysRemark(remark)">
                      <div class="startTime">
                        <WmsTimeInput2
                          name="remarkStartTime"
                          caption="作業開始時間"
                          :clearable="true"
                          v-model="remark.startTime"
                          :hourItems="hourItems"
                          :minuteItems="minuteItems"
                          :disabled="isDisabled || referenceMode"
                        />
                      </div>

                      <div class="endTime">
                        <WmsTimeInput2
                          name="remarkEndTime"
                          caption="作業終了時間"
                          :clearable="true"
                          v-model="remark.endTime"
                          :hourItems="hourItems"
                          :minuteItems="minuteItems"
                          :disabled="isDisabled || referenceMode"
                        />
                      </div>

                      <div v-if="remark.hours||remark.hours==0" class="ml-3">
                        <div class="text-xs font-bold text-gray-700 mb-1">実働時間</div>
                        <input
                          type="number"
                          v-model="remark.hours"
                          @focus="inputFocus"
                          class="border-gray-300 rounded text-sm px-2 py-1.5 text-center"
                        />
                      </div>
                    </div>

                    <div class="deleteButton" v-if="!referenceMode && !isDisabled">
                      <PrimaryButton class="bg-red-500" size="other" :buttonContents="'要'" v-tooltip="'削除'" @click="removeWorkRemarks(det.remarks, index)">
                        <Icon slot="before" iconName="MinusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
                      </PrimaryButton>
                    </div>
                  </div>
                </div>

                <!-- 日常・管理 作業詳細追加ボタン -->
                <div class="sm:col-span-full addButton-contents mt-2" v-if="!referenceMode && !isDisabled && ['3', '4'].includes(o.categoryCode)">
                  <PrimaryButton class="bg-green-500" size="other" :buttonContents="'要'" v-tooltip="'作業曜日・時間追加'" @click="addWorkRemarks(det.remarks)">
                    <Icon slot="before" iconName="PlusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
                  </PrimaryButton>
                </div>
              </div>
            </div>

            <!-- RLS、MRS -->
            <div v-if="o.count2 && o.categoryCode!='2'" class=" mt-3 sm:col-span-full button-w-sm">
              <OrderItemSelect
                :name="p + 'Count2'"
                caption="清掃希望回数"
                v-model="o.count2"
                :item="o.categoryCode=='29'?selectCleanCountItemMonthMRS:selectCleanCountItemMonth"
                :disabled="true"
              />
            </div>

            <!-- MRSのゴミ搬出回数（見積りの詳細モーダルの値をそのまま出す・編集不可） -->
            <div v-if="o.categoryCode=='29'" class="mt-3 sm:col-span-2">
              <WmsTextInput
                :name="p + 'TrashCount'"
                caption="ゴミ搬出回数"
                :value="getMrsTrashCount(o)"
                :disabled="true"
              />
            </div>

            <!-- 見積りの数量2 -->
            <div v-if="!o.count2 && o.dispCount" class="sm:col-span-full mt-3">
              <WmsTextInput
                :name="p + 'Count'"
                caption="清掃希望回数"
                v-model="o.dispCount"
                :disabled="true"
              />
            </div>

            <div class="mt-3" v-if="o.categoryCode!='2' && (o.startDate || o.startDate == '') && !isTaskRequestMode && !referenceMode">
              <WmsDateInput
                :name="p + 'StartDate'"
                caption="開始日"
                v-model="o.startDate"
                :readonly="isTaskRequestMode || referenceMode"
                :clearable="true"
              />
            </div>

            <div class="mt-3 sm:col-span-2"  v-if="o.categoryCode!='2' && (o.startDate || o.startDate == '') && (isTaskRequestMode || referenceMode)">
              <WmsTextInput
                name="estimationRoundStartDate"
                caption="開始日"
                v-model="o.startDate"
                :disabled="true"
              />
            </div>

            <div class="mt-3 sm:col-span-full" v-if="o.categoryCode!='2'&&o.workDays">
              <div class="text-xs font-bold text-gray-700 mb-1">作業曜日</div>
              <div class="flex text-sm">
                <div v-for="(w, wi) in selectItemWeek" :key="i+'w'+oI+'w'+wi"
                  style="width: 14%; margin-right: 1px;"
                  class="border border-gray-200 py-2 text-center"
                  :class="[o.workDays.includes(w.value)?'bg-indigo-900 text-white font-bold':'bg-white text-gray-700', (isDisabled || referenceMode)?'cursor-not-allowed':'cursor-pointer']"
                  @click="clickWorkDays(w.value, o)"
                >
                  {{ w.text }}
                </div>
              </div>
            </div>

            <div v-if="o.categoryCode!='2'&&o.workDays">
              <!-- 毎週OR第●週 -->
              <div class="flex">
                <div v-for="(w, wi) in selectItemWeek" :key="i+'w'+oI+'wd'+wi" style="width: 14%; margin-right: 1px;">

                  <multiselect
                    v-if="!isDisabled"
                    v-model="o.weekDetail[w.value]"
                    :options="weekDetailList"
                    :multiple="true"
                    :close-on-select="false"
                    :show-labels="false"
                    :searchable="false"
                    :allow-empty="true"
                    :hide-selected="true"
                    placeholder=""
                    class="multiselect"
                    :disabled="!o.workDays.includes(w.value) || isDisabled || referenceMode"
                    @input="reload++"
                  >
                  </multiselect>
                  <!-- サブタスクでの表示（小さくてわからない） -->
                  <div v-else class="border border-gray-200 rounded text-center py-1 text-sm text-gray-600 bg-gray-50">
                    <div v-if="o.weekDetail[w.value]" class="whitespace-pre-line">
                      {{ o.weekDetail[w.value].join('\n') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-3 sm:col-span-full" v-if="o.categoryCode!='2'&&o.newYearHolidaysRls">
              <div class="text-xs font-bold text-gray-700 mb-1">年末年始</div>
              <div v-if="isMitsui" class="text-xs font-bold text-red-700 mb-1">＊三井不動産様は、12/30は出勤日です</div>
              <div class="flex text-sm" v-if="o.newYearHolidaysRls.length||isMitsui">
                <div v-for="(n, nI) in [30, 31, 1, 2, 3]" :key="i+'n'+oI+'n'+nI"
                  style="width: 14%; margin-right: 1px;"
                  class="border border-gray-200 py-2 text-center cursor-not-allowed"
                  :class="o.newYearHolidaysRls.includes(n)||(isMitsui&&n==30)?'bg-indigo-900 text-white font-bold':'bg-white text-gray-600'"
                >
                  {{ n }}
                </div>
              </div>
              <div v-else class="bg-gray-200 text-gray-700 text-sm py-1.5 px-3 rounded border border-gray-300 cursor-not-allowed">
                なし
              </div>
            </div>

            <div class="mt-3 sm:col-span-full button-w-sm2" v-if="o.categoryCode!='2' && o.photo">
              <WmsTextInput
                :name="p + 'photo'"
                caption="写真報告"
                v-model="o.photo"
                :disabled="true"
              />
            </div>

            <div class="mt-3 sm:col-span-full" v-if="o.categoryCode!='2' && (o.firstWorkYear || o.firstWorkYear == '')">
              <WmsSuggestInput
                :name="p + 'FirstWorkYear'"
                caption="初回作業年"
                :dynamic="false"
                :incrementalSearch="false"
                :selectionItems="selectItemYear"
                displayField="text"
                :filter="{}"
                :clearable="true"
                v-model="o.firstWorkYear"
                :disabled="isDisabled || referenceMode"
              />
            </div>

            <div class="mt-3 sm:col-span-full button-w-sm3" v-if="o.categoryCode!='2' && o.firstWorkMonth">
              <OrderItemSelect
                :name="p + 'FirstWorkMonth'"
                caption="初回作業月"
                v-model="o.firstWorkMonth"
                :multiSelect="false"
                :item="selectItemMonth"
                :disabled="isDisabled || referenceMode"
                @change="changeFirstWorkMonth($event, oI, p)"
              />
            </div>

            <div class="sm:col-span-full mt-3 button-w-sm3" v-if="o.categoryCode!='2' && o.implementationMonth">
              <OrderItemSelect
                :name="p + 'ImplementationMonth'"
                caption="実施月"
                v-model="o.implementationMonth"
                :item="selectItemMonth"
                :disabled="isDisabled || referenceMode"
              />
            </div>

            <!-- スポット清掃 -->
            <div v-if="o.categoryCode == '28'">
              <div class="flex grid grid-cols-6 gap-2">
                <div class="mt-3 col-span-3">
                  <WmsSuggestInput
                    name="area"
                    caption="対象箇所"
                    :dynamic="false"
                    :incrementalSearch="false"
                    :selectionItems="regularCleanTargetAreaSelectItem"
                    displayField="text"
                    :filter="{}"
                    :clearable="true"
                    v-model="o.area"
                    :disabled="isDisabled || referenceMode"
                  />
                </div>

                <div class="mt-3 col-span-3">
                  <WmsSuggestInput
                    name="work"
                    caption="作業内容"
                    :dynamic="false"
                    :incrementalSearch="false"
                    :selectionItems="regularCleanDescriptionWorkSelectItem"
                    displayField="text"
                    :filter="{}"
                    :clearable="true"
                    v-model="o.workDetail"
                    :disabled="isDisabled || referenceMode"
                  />
                </div>
              </div>

              <!-- <div class="mt-3 sm:col-span-1">
                <OrderItemSelect
                  name="carpet"
                  caption="カーペット"
                  v-model="o.carpet"
                  :item="selectItemCarpet"
                  :disabled="isDisabled || referenceMode"
                />
              </div> -->
            </div>

            <div v-if="o.unitPrice || o.unitPrice == ''" class="mt-3">
              <WmsTextInput
                :name="p + 'UnitPrice'"
                caption="受注単価（税抜き）"
                v-model="o.unitPrice"
                :disabled="true"
              />
            </div>

            <div v-if="o.unitPrice || o.unitPrice == ''" class="mt-3">
              <WmsTextInput
                :name="p + 'Amount'"
                caption="受注総額（税抜き）"
                v-model="o.amount"
                :disabled="true"
              />
            </div>

            <div v-if="o.monthlyFee || o.monthlyFee == ''" class="mt-3">
              <WmsTextInput
                :name="p + 'mf'"
                caption="月額（税抜き）"
                v-model="o.monthlyFee"
                :disabled="true"
              />
            </div>

            <div class="sm:col-span-full mt-3" v-if="o.supplier || o.supplier == ''">
              <WmsTextInput
                :name="p + 'Supplier'"
                caption="発注先名"
                v-model="o.supplier"
                :disabled="isDisabled || referenceMode"
              />
            </div>

            <div class="sm:col-span-full mt-3" v-if="o.orderPrice || o.orderPrice == ''">
              <WmsTextInput
                :name="p + 'Price'"
                caption="発注金額"
                v-model="o.orderPrice"
                :disabled="true"
              />
            </div>

            <!-- RLSプラスの発注（配列） -->
            <div v-if="['2'].includes(o.categoryCode)">
              <!-- 新仕様のラウンドプラス発注明細の場合 2023.07.25から新仕様 -->
              <div v-if="o.purchase && o.purchase.length" class="sm:col-span-full mt-5 mb-10">
                <div v-for="(row, rlsPI) in o.purchase" v-bind:key="'rlsPuls' + rlsPI">

                  <div v-if="row.typeName" class="text-xs mt-10 font-bold text-blue-500">
                    --- {{row.typeName}} ---
                  </div>

                  <!-- 巡回清掃RLSプラスの場合 -->
                  <div v-if="row.typeName && row.typeName.indexOf('巡回清掃')>-1">
                    <!-- 巡回清掃RLSプラスの開始日 -->
                    <div class="mt-3" v-if="(o.startDate || o.startDate == '') && !isTaskRequestMode && !referenceMode">
                      <WmsDateInput
                        :name="p + 'StartDate'"
                        caption="開始日"
                        v-model="o.startDate"
                        :readonly="isTaskRequestMode || referenceMode"
                        :clearable="true"
                      />
                    </div>

                    <div class="mt-3 sm:col-span-2" v-if="(o.startDate || o.startDate == '') && (isTaskRequestMode || referenceMode)">
                      <WmsTextInput
                        name="estimationRoundStartDate"
                        caption="開始日"
                        v-model="o.startDate"
                        :disabled="true"
                      />
                    </div>

                    <!-- 巡回清掃RLSプラスの清掃希望回数 -->
                    <div class=" mt-3 sm:col-span-full button-w-sm">
                      <OrderItemSelect
                        :name="p + 'Count2'"
                        caption="清掃希望回数"
                        v-model="o.count2"
                        :item="selectCleanCountItemMonth"
                        :disabled="true"
                      />
                    </div>

                    <div class="mt-3 sm:col-span-full" v-if="o.workDays">
                      <div class="text-xs font-bold text-gray-700 mb-1">作業曜日</div>
                      <div class="flex text-sm">
                        <div v-for="(w, wi) in selectItemWeek" :key="i+'w'+oI+'w'+wi"
                          style="width: 14%; margin-right: 1px;"
                          class="border border-gray-200 py-2 text-center"
                          :class="[o.workDays.includes(w.value)?'bg-indigo-900 text-white font-bold':'bg-white text-gray-700', (isDisabled || referenceMode)?'cursor-not-allowed':'cursor-pointer']"
                          @click="clickWorkDays(w.value, o)"
                        >
                          {{ w.text }}
                        </div>
                      </div>
                    </div>

                    <div v-if="o.workDays">
                      <!-- 毎週OR第●週 -->
                      <div class="flex">
                        <div v-for="(w, wi) in selectItemWeek" :key="i+'w'+oI+'wd'+wi" style="width: 14%; margin-right: 1px;">

                          <multiselect
                            v-if="!isDisabled"
                            v-model="o.weekDetail[w.value]"
                            :options="weekDetailList"
                            :multiple="true"
                            :close-on-select="false"
                            :show-labels="false"
                            :searchable="false"
                            :allow-empty="true"
                            :hide-selected="true"
                            placeholder=""
                            class="multiselect"
                            :disabled="!o.workDays.includes(w.value) || isDisabled || referenceMode"
                            @input="reload++"
                          >
                          </multiselect>
                          <!-- サブタスクでの表示（小さくてわからない） -->
                          <div v-else class="border border-gray-200 rounded text-center py-1 text-sm text-gray-600 bg-gray-50">
                            <div v-if="o.weekDetail[w.value]" class="whitespace-pre-line">
                              {{ o.weekDetail[w.value].join('\n') }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="mt-3 sm:col-span-full" v-if="o.newYearHolidaysRls">
                      <div class="text-xs font-bold text-gray-700 mb-1">年末年始</div>
                      <div v-if="isMitsui" class="text-xs font-bold text-red-700 mb-1">＊三井不動産様は、12/30は出勤日です</div>
                      <div class="flex text-sm" v-if="o.newYearHolidaysRls.length||isMitsui">
                        <div v-for="(n, nI) in [30, 31, 1, 2, 3]" :key="i+'n'+oI+'n'+nI"
                          style="width: 14%; margin-right: 1px;"
                          class="border border-gray-200 py-2 text-center cursor-not-allowed"
                          :class="o.newYearHolidaysRls.includes(n)||(isMitsui&&n==30)?'bg-indigo-900 text-white font-bold':'bg-white text-gray-600'"
                        >
                          {{ n }}
                        </div>
                      </div>
                      <div v-else class="bg-gray-200 text-gray-700 text-sm py-1.5 px-3 rounded border border-gray-300 cursor-not-allowed">
                        なし
                      </div>
                    </div>

                    <div class="mt-3 sm:col-span-full" v-if="o.photo">
                      <WmsTextInput
                        :name="p + 'photo'"
                        caption="写真報告"
                        v-model="o.photo"
                        :disabled="true"
                      />
                    </div>
                  </div>

                  <!-- 固定清掃RLSプラスの場合 -->
                  <div v-else-if="row.typeName && row.typeName.indexOf('固定清掃')>-1">

                    <div v-if="['2'].includes(o.categoryCode)&&o.specificTime" class="sm:col-span-full">
                      <OrderItemSelect
                        v-if='o.normalCount'
                        :name="p + 'normalCount'"
                        caption="清掃希望回数"
                        v-model="o.normalCount"
                        :item="selectEstimationEverydayCountItemMonth(o.normalCount)"
                        :disabled="true"
                        class="mt-3 button-w-sm"
                      />

                      <OrderItemSelect
                        :name="p + 'specificTime'"
                        caption="時間指定"
                        v-model="o.specificTime"
                        :item="selectItemCommissionFlag"
                        :disabled="true"
                        class="mt-3"
                      />

                      <OrderItemSelect
                        v-if="o.holiday"
                        :name="p + 'holi'"
                        caption="祝日対応"
                        v-model="o.holiday"
                        :item="holiday"
                        :disabled="true"
                        class="mt-3"
                      />

                      <div class="mt-3 sm:col-span-full" v-if="o.newYearHolidays">
                        <div class="text-xs font-bold text-gray-700 mb-1">年末年始</div>
                        <div v-if="isMitsui" class="text-xs font-bold text-red-700 mb-1">＊三井不動産様は、12/30は出勤日です</div>
                        <div class="flex text-sm" v-if="o.newYearHolidays.length||isMitsui">
                          <div v-for="(n, nI) in [30, 31, 1, 2, 3]" :key="i+'n'+oI+'n'+nI"
                            style="width: 14%; margin-right: 1px;"
                            class="border border-gray-200 py-2 text-center cursor-not-allowed"
                            :class="o.newYearHolidays.includes(n)||(isMitsui&&n==30)?'bg-indigo-900 text-white font-bold':'bg-white text-gray-600'"
                          >
                            {{ n }}
                          </div>
                        </div>
                        <div v-else class="bg-gray-200 text-gray-700 text-sm py-1.5 px-3 rounded border border-gray-300 cursor-not-allowed">
                          なし
                        </div>
                      </div>
                    </div>

                    <!-- RLSプラスの曜日時間（人数分） -->
                    <div class="sm:col-span-full mt-3" v-if="['2'].includes(o.categoryCode)">
                      <div v-for="(remark, index) in o.remarks" v-bind:key="500 + index">
                        <div class="sm:col-span-full" :class="{'mt-6': index > 0}">
                          <label
                            name="idxLabel"
                            class="text-sm font-bold"
                          >
                            【{{index + 1}}】
                          </label>
                        </div>

                        <!-- <div class="sm:col-span-full button-w-sm2">
                          <OrderItemSelect
                            name="remarkDays"
                            caption="作業曜日"
                            v-model="remark.workDays"
                            :item="selectItemWeek"
                            :disabled="isDisabled || referenceMode"
                          />
                        </div>

                        <div v-if="remark.weekDetail">
                          <OrderWeekDetailSelect
                            v-model="remark.weekDetail"
                            :selectedWeeks="remark.workDays"
                            :weekDetail="remark.weekDetail"
                            :idx="index+''+i"
                            :disabled="isDisabled || referenceMode"
                          />
                        </div> -->

                        <!-- 曜日ごとの形（契約詳細入力画面と同じ。1行＝1人。見積から作った受注はこの形。過去の受注は下の形のまま） -->
                        <div class="sm:col-span-full" v-if="isDaysRemark(remark)">
                          <div class="text-xs font-bold text-gray-700 mb-1">作業曜日・時間（曜日を押すと勤務あり／なし）</div>
                          <OrderRemarkDays :remark="remark" :disabled="isDisabled || referenceMode" @change="reload++" />
                        </div>
                        <!-- 新しい形 -->
                        <div class="sm:col-span-full" v-else-if="remark.weekDetail && typeof remark.weekDetail === 'object' && !Array.isArray(remark.weekDetail)">
                          <div class="text-xs font-bold text-gray-700 mb-1">作業曜日</div>
                          <div class="flex text-sm">
                            <div v-for="(w, wi) in selectItemWeek" :key="i+'w'+oI+'r'+index+'w'+wi"
                              style="width: 14%; margin-right: 1px;"
                              class="border border-gray-200 py-2 text-center"
                              :class="[remark.workDays.includes(w.value)?'bg-indigo-900 text-white font-bold':'bg-white text-gray-700', (isDisabled || referenceMode)?'cursor-not-allowed':'cursor-pointer']"
                              @click="clickWorkDays(w.value, remark)"
                            >
                              {{ w.text }}
                            </div>
                          </div>

                          <div v-if="remark.weekDetail">
                            <!-- 毎週OR第●週 -->
                            <div class="flex">
                              <div v-for="(w, wi) in selectItemWeek" :key="i+'w'+oI+'r2'+index+'wd'+wi" style="width: 14%; margin-right: 1px;">

                                <multiselect
                                  v-if="!isDisabled"
                                  v-model="remark.weekDetail[w.value]"
                                  :options="weekDetailList"
                                  :multiple="true"
                                  :close-on-select="false"
                                  :show-labels="false"
                                  :searchable="false"
                                  :allow-empty="true"
                                  :hide-selected="true"
                                  placeholder=""
                                  class="multiselect"
                                  :disabled="!remark.workDays.includes(w.value) || isDisabled || referenceMode"
                                  @input="reload++"
                                >
                                </multiselect>
                                <!-- サブタスクでの表示（小さくてわからない） -->
                                <div v-else class="border border-gray-200 rounded text-center py-1 text-sm text-gray-600 bg-gray-50">
                                  <div v-if="remark.weekDetail[w.value]" class="whitespace-pre-line">
                                    {{ remark.weekDetail[w.value].join('\n') }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- 以前の形 -->
                        <div v-else class="sm:col-span-full" >
                          <div class=" button-w-sm2">
                            <OrderItemSelect
                              name="remarkDays"
                              caption="作業曜日"
                              v-model="remark.workDays"
                              :item="selectItemWeek"
                              :disabled="isDisabled || referenceMode"
                            />
                          </div>
                          <div v-if="remark.weekDetail">
                            <OrderWeekDetailSelect
                              v-model="remark.weekDetail"
                              :selectedWeeks="remark.workDays"
                              :weekDetail="remark.weekDetail"
                              :idx="index+''+i"
                              :disabled="isDisabled || referenceMode"
                            />
                          </div>
                        </div>

                        <!-- 行に時間が1組の形（曜日ごとの形は曜日の中に時間がある） -->
                        <div class="flex mt-ec" v-if="!isDaysRemark(remark)">
                          <div class="startTime">
                            <WmsTimeInput2
                              name="remarkStartTime"
                              caption="作業開始時間"
                              :clearable="true"
                              v-model="remark.startTime"
                              :hourItems="hourItems"
                              :minuteItems="minuteItems"
                              :disabled="isDisabled || referenceMode"
                            />
                          </div>

                          <div class="endTime">
                            <WmsTimeInput2
                              name="remarkEndTime"
                              caption="作業終了時間"
                              :clearable="true"
                              v-model="remark.endTime"
                              :hourItems="hourItems"
                              :minuteItems="minuteItems"
                              :disabled="isDisabled || referenceMode"
                            />
                          </div>

                          <div v-if="remark.hours||remark.hours==0" class="ml-3">
                            <div class="text-xs font-bold text-gray-700 mb-1">実働時間</div>
                            <input
                              type="number"
                              v-model="remark.hours"
                              @focus="inputFocus"
                              class="border-gray-300 rounded text-sm px-2 py-1.5 text-center"
                            />
                          </div>
                        </div>

                        <div class="flex justify-end" v-if="!referenceMode && !isDisabled">
                          <!-- 追加ボタン -->
                          <div class="sm:col-span-full addButton-contents mr-2" v-if="index==o.remarks.length-1">
                            <PrimaryButton class="bg-green-500" size="other" :buttonContents="'要'" v-tooltip="'作業曜日・時間追加'" @click="addWorkRemarks(o.remarks)">
                              <Icon slot="before" iconName="PlusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
                            </PrimaryButton>
                          </div>
                          <!-- 削除ボタン -->
                          <div class="deleteButton">
                            <PrimaryButton class="bg-red-500" size="other" :buttonContents="'要'" v-tooltip="'削除'" @click="removeWorkRemarks(o.remarks, index)">
                              <Icon slot="before" iconName="MinusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
                            </PrimaryButton>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>

                  <!-- 定期清掃RLSプラスの場合 -->
                  <div v-else-if="row.typeName && row.typeName.indexOf('定期清掃')>-1">
                    <div class="mt-3 sm:col-span-full">
                      <!-- 定期清掃RLSプラスの初回年 -->
                      <WmsSuggestInput
                        :name="p + 'FirstWorkYear'"
                        caption="初回作業年"
                        :dynamic="false"
                        :incrementalSearch="false"
                        :selectionItems="selectItemYear"
                        displayField="text"
                        :filter="{}"

                        :clearable="true"
                        v-model="o.firstWorkYear"
                        :disabled="isDisabled || referenceMode"
                      />
                    </div>

                    <div class="mt-3 sm:col-span-full button-w-sm3">
                      <!-- 定期清掃RLSプラスの初回年 -->
                      <OrderItemSelect
                        :name="p + 'FirstWorkMonth'"
                        caption="初回作業月"
                        v-model="o.firstWorkMonth"
                        :multiSelect="false"
                        :item="selectItemMonth"
                        :disabled="isDisabled || referenceMode"
                      />
                    </div>

                    <div class="mt-3 sm:col-span-full">
                      <!-- 定期清掃RLSプラスの通常・簡易の実施月 -->
                      <OrderItemSelect
                        :name="p + 'ImplementationMonth'"
                        caption="作業月"
                        v-model="o.implementationMonth"
                        :multiSelect="false"
                        :item="selectItemMonth2"
                        :disabled="isDisabled || referenceMode"
                      />
                    </div>

                  </div>

                  <div class="mt-2">
                    <WmsTextInput
                      name="RoundPlusPurchaseSupplier"
                      caption="発注先名"
                      v-model="row.supplier"
                      :disabled="isDisabled || referenceMode"
                    />
                  </div>

                  <div class="mt-2">
                    <WmsTextInput
                      name="RoundPlusPurchasePrice"
                      caption="発注金額"
                      v-model="row.price"
                      :disabled="true"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="sm:col-span-full mt-3">
              <OrderItemSelect
                :name="p + 'CommissionFlag'"
                caption="手数料有無"
                v-model="o.commissionFlag"
                :item="selectItemCommissionFlag"
                :disabled="true"
              />
            </div>

            <div class="sm:col-span-full mt-3" v-if="o.commissionFlag && o.commissionFlag.length && o.commissionFlag[0] == '1'">
              <WmsTextInput
                :name="p + 'CommissionPrice'"
                caption="手数料金額"
                v-model="o.commissionPrice"
                :disabled="true"
              />
            </div>

            <div class="sm:col-span-full mt-3">
              <WmsTextInput
                :name="p + 'Memo'"
                caption="メモ"
                :multiline="true"
                :rows="5"
                v-model="o.memo"
                :disabled="isDisabled || referenceMode"
              />
            </div>
            <div class="sm:col-span-full mt-3" v-if="i<10 && o.file">
              <label class="block text-xs font-bold text-gray-700">
                {{o.name}} 添付資料
              </label>
              <div class="mt-1">
                <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                  <WmsAttachment
                    :name="p + 'CommonFile'"
                    caption="添付資料"
                    :value="order[`${o.file}${i+1}`]"
                    style="max-width: none!important;"
                    @change="attachmentChange(`${o.file}${i+1}`, $event)"
                    :disabled="isDisabled || referenceMode"
                    :readonly="isDisabled || referenceMode"
                  />
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- 以下の添付はカテゴリ1つにつき添付1つ -->

        <div v-for="ps in propertySet" :key="ps.code">
          <div class="mt-3 mx-5 mb-3 sm:col-span-full" v-if="ps.file && p == ps.val">
            <label class="block text-xs font-bold text-gray-700">
              {{ps.name}} 添付資料
            </label>
            <div class="mt-1">
              <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                <WmsAttachment
                  :name="ps.file"
                  caption="添付資料"
                  :value="order[ps.file]"
                  style="max-width: none!important;"
                  @change="attachmentChange(ps.file, $event)"
                  :disabled="isDisabled || referenceMode"
                  :readonly="isDisabled || referenceMode"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="sm:col-span-full">
      <div class="flex">
        <div class="text-xs my-auto font-bold text-gray-700">配信用テンプレート</div>
        <PrimaryButton text="テンプレート更新" v-tooltip="'受注の内容をテンプレートに反映します'" size="xs" class="ml-3" @click="setTemplateHTL()" :disabled="isDisabled || referenceMode"></PrimaryButton>
      </div>
      <OrderRichTextInput
        name="template"
        :value="templateHTML"
        v-model="templateHTML"
        @change="templateChange($event)"
        :disabled="isDisabled || referenceMode"
      >
      </OrderRichTextInput>

      <!-- 発注先ごとに配信テンプレート表示 -->
      <div v-if="order.tempBypur&&Object.keys(order.tempBypur).length">
        <div v-for="(bp, bpIdx) in Object.keys(order.tempBypur)" :key="'bp'+bpIdx" class="mt-5">
          <!-- 自社発注は表示不要 -->
          <WmsTextInput
            v-if="bp.indexOf('アポロ')==-1"
            :caption="bp"
            :multiline="true"
            :rows="getRows(order.tempBypur[bp])"
            v-model="order.tempBypur[bp]"
            :disabled="isDisabled || referenceMode"
          />
        </div>
      </div>
      <div class="hidden">{{reload}}</div>
    </div>

    <!-- 作業内容コード選択モーダル -->
    <SelectWorkCode
      v-model="workCodeModalShow"
      :target="workCode.target"
      :open="workCodeModalShow"
      :allList="workCodeList"
      @selectWorkCodeClose="closeWorkCode"
    />
  </div>
</template>

<script>
  import PrimaryButton from '@components/PrimaryButton.vue'
  import Icon from '@components/Icon.vue'
  import OrderItemSelect from './OrderItemSelect.vue'
  import OrderWeekDetailSelect from './OrderWeekDetailSelect.vue'
  import SelectWorkCode from './SelectWorkCode.vue'
  import WmsDateInput from '@wmscomponents/WmsDateInput.vue'
  import WmsTextInput from '@wmscomponents/WmsTextInput.vue'
  import EstimationDetailsCategorySelect from './EstimationDetailsCategorySelect.vue'
  import InputGroupSubLabel from './InputGroupSubLabel.vue'
  import OrderRichTextInput from './OrderRichTextInput.vue'
  import WmsSuggestInput from '@wmscomponents/WmsSuggestInput.vue'
  import InputIcon from '@components/InputIcon.vue'
  import WmsAttachment from '@wmscomponents/WmsAttachment.vue'
  import WmsTimeInput2 from '@wmscomponents/WmsTimeInput2.vue'
  import OrderRemarkDays from './OrderRemarkDays.vue'
  import { isDaysRemark, blankDaysRemark, daysRemarkFromEstimate, groupDaysByTime } from '@libs/orderRemark'
  import Multiselect from 'vue-multiselect'
  import BigNumber from 'bignumber.js'
  import * as estimateManager from '@managers/estimateManager'
  import * as orderManager from '@managers/orderManager'
  import * as taskRequestManager from '@managers/taskRequestManager'
  import { isContractTarget, missingStartDates, contractTargetNames } from '@libs/akbsContractFromOrder'
  import { AKBS_SUB_TASK, isAkbsSubTask } from '@libs/constantsAKBS'
  import * as constants from '@libs/constants'
  import * as dialogs from '@libs/dialogs'
  import * as backend from '@libs/backend'
  import * as utils from '@libs/utils'
  import * as moment from 'moment'

  const thisYear = (new Date()).getFullYear() + '年'

  // 物件情報に物件番号が必要な得意先（新規のみ）
  const siteCodeForNewSite = ['東急', 'アートアベニュー', '三菱', 'セキスイ', 'ナイス', '長谷工', '大和地所', '大京', '野村不動産']
  // 物件情報にチームが必要な得意先
  const teamForNewSite = ['東急']

  // 見積カテゴリのプロパティ
  const PROP = [
    // ラウンドサービス
    'orderRls',
    // ラウンドプラス
    'orderRlsPlus',
    // 日常清掃
    'orderEverydays',
    // 管理
    'orderManagerWorks',
    // 定期
    'orderRegular',
    // フロントサポート
    'orderFront',
    // フロントサポートプラス
    'orderFrontPlus',
    // ランドトラッシュ
    'orderRlsTrash',
    // クオリティーレポート
    'orderQuality',
    // ガラス清掃
    'orderGlass',
    // 排水管清掃
    'orderDrain',
    // 貯水槽清掃➡受水槽清掃に変更
    'orderWaterTank',
    // 植栽剪定
    'orderPlanting',
    // 特別清掃
    'orderSpecialCleans',
    // 消防設備点検
    'orderFire',
    // 建築設備定期検査
    'orderConstruction',
    // 特定建築物定期調査
    'orderSpConstruction',
    // 共用部設備点検
    'orderCommon',
    // エレベータ保守点検
    'orderEv',
    // 増圧ポンプ点検
    'orderPress',
    // 給排水ポンプ点検
    'orderWaterSupply',
    // 簡易専用水道
    'orderSimpleWater',
    // 管球対応
    'orderTube',
    // 粗大ごみ
    'orderBulkyTrash',
    // 物品販売
    'orderSale',
    // 緊急対応
    'orderEmergency',
    // 防火対象物点検
    'orderFireObj',
    // 汚水槽清掃
    'orderSewage',
    // 防火設備定期検査
    'orderFireFixed',
    // 連結送水管耐圧性能点検
    'orderConnented',
    // スポット清掃
    'orderSpot',
    // MRS
    'orderMRS',
    // カテゴリーなし
    'orderOthers'
  ]

  export default {
    components: {
      PrimaryButton,
      Icon,
      OrderItemSelect,
      OrderWeekDetailSelect,
      SelectWorkCode,
      WmsDateInput,
      WmsTextInput,
      EstimationDetailsCategorySelect,
      InputGroupSubLabel,
      OrderRichTextInput,
      WmsSuggestInput,
      InputIcon,
      WmsAttachment,
      WmsTimeInput2,
      Multiselect,
      OrderRemarkDays
    },

    props: {
      estimateData: {
        type: Object,
        default: () => {}
      },
      orderData: {
        type: Object,
        default: () => {}
      },
      mainData: {
        type: Object,
        default: () => {}
      },
      isDisabled: {
        type: Boolean,
        default: false
      },
      isTaskRequestMode: {
        type: Boolean,
        default: false
      },
      referenceMode: {
        type: Boolean,
        default: false
      },
      position: {
        type: String,
        default: ''
      },
      // 得意先に紐づく物件リスト
      buildingListByClient: {
        type: Array,
      },
    },

    data() {
      return {
        loading: false,
        reload: 0,
        order: orderManager.createNewOrderModel(),
        originalOrder: {},
        isSaving: false,
        initialized: false,
        saved: false,
        detailSorting: false,
        estimate: {},
        selectItemWeek: [],
        selectItemMonth: [],
        selectItemMonth2: [],
        templateHTML: '',
        dispContractDate: '',
        dispContractEndDate: '',
        selectItemYear: [],
        estimationRoundPlusCategorySelectItem:[],
        selectItemCarpet: [],
        regularCleanTargetAreaSelectItem: [],
        regularCleanDescriptionWorkSelectItem: [],
        workItemList: [],
        selectItemClassification: [],
        selectItemCommissionFlag: [],
        holiday: [],
        hourItems: [],
        minuteItems: [],
        // 見積りカテゴリーのプロパティー
        property: PROP,
        // カテゴリーコード、カテゴリー名、プロパティー名、ファイル名のセット
        propertySet: constants.PROPSET,
        // 作業内容コードリスト
        workCodeList: [],
        // 作業内容モーダル表示
        workCodeModalShow: false,
        // 編集対象の作業内容
        workCode: {},
        // 均等請求リスト
        selectItemMonthlyFeeFlag: [],
        // 毎週、第何週
        weekDetailList: constants.WEEK_DETAIL,
        // サブタスク画面から初回作業日更新
        updateStartMemo: false,
        // 作業開始日の背景色
        startMemoBgColor: false,
        // この受注のサブタスクに「契約詳細登録申請」があるか（あれば契約詳細入力画面へのボタンを出す）
        hasContractSubTask: false
      }
    },

    mounted() {
      this.$nextTick(async () => {
        // サブ一覧から遷移した場合は、一番下にスクロール
        if (this.position && this.position == 'template') {
          await utils.wait(900)
          const el = document.getElementById('el');
          el.scrollIntoView(false)
        }
      })
    },

    computed: {
      /**
       * 契約詳細情報の登録の帯を出すか
       * 対象の受注（日常清掃・管理員業務・固定清掃のあるラウンドプラス。区分は関係なし）で、サブタスクに「契約詳細登録申請」があるとき
       */
      showContractDetail() {
        return this.hasContractSubTask && isContractTarget(this.order)
      },

      /**
       * 契約詳細情報の登録の対象になっているカテゴリーの名前（帯の案内文の「○○のメインタスク」に使う）
       */
      contractTargetNames() {
        return contractTargetNames(this.order)
      },

      /**
       * 契約日バリデート
       */
      validateContractDate() {
        if (!this.order.contractDate) {
          return{
            result: false,
            message: '契約日は必須です。'
          }
        } else {
          return {
            result: true,
            message: ''
          }
        }
      },

      /**
       * 契約終了日バリデート
       */
      validateContractEndDate() {
        if (this.order.contractEndDate != '' && this.order.contractDate != '' && this.order.contractDate > this.order.contractEndDate) {
          return{
            result: false,
            message: '契約日、契約終了日が不正です。'
          }
        } else if (!this.order.contractEndDate) {
          return{
            result: false,
            message: '契約終了日は必須です。'
          }
        } else {
          return {
            result: true,
            message: ''
          }
        }
      },

      validateClassification() {
        if (!this.order.classification || this.order.classification.length == 0 || this.order.classification[0] == '2') {
          return {
            result: false,
            message: '区分は必須入力です。区分を選択してください。'
          }
        } else {
          return {
            result: true,
            message: ''
          }
        }
      },

      getRows() {
        return (val) => {
          let num = 5
          if (val) {
            let count = val.match(/\r\n|\n/g).length + 2
            if (count >= 5) {
              return count
            }
          }
          return num
        }
      },

      /**
       * 日常・管理の清掃回数
       */
      selectEstimationEverydayCountItemMonth() {
        return (val) => {
          if (val && val.length) {
            return [{ value: val[0], text: val[0] }]
          }
          return []
        }
      },

      /**
       * 三井不動産か判定
       */
      isMitsui() {
        if (this.order.clientName) {
          if (utils.hankaku(this.order.clientName).indexOf('三井不動産') > -1 || utils.hankaku(this.order.clientName).indexOf('ｴﾑ･ｴﾌ') > -1) {
            return true
          }
        } else if (this.mainData.clientName) {
          if (utils.hankaku(this.mainData.clientName).indexOf('三井不動産') > -1 || utils.hankaku(this.mainData.clientName).indexOf('ｴﾑ･ｴﾌ') > -1) {
            return true
          }
        }
        return false
      },
    },

    async created() {
      this.initialized = false
      await this.setOrder()
      this.initialized = true
      // 契約詳細情報の登録の帯を出すか（サブタスクに「契約詳細登録申請」があるか）
      await this.loadContractSubTask()
    },

    methods: {
      /**
       * この受注のサブタスクに「契約詳細登録申請」があるかを取る（あれば、契約詳細入力画面へのボタンを出す）
       * 契約詳細情報を登録するかどうかを最終的に決めるのはユーザーで、そのサブタスクを立てたときだけ入口を出す
       * サブタスクはメインタスクを保存したあとで依頼するものなので、未保存（_id 無し）なら無いまま
       */
      async loadContractSubTask() {
        this.hasContractSubTask = false
        if (!this.order || !this.order._id) {
          return
        }
        const subTasks = await taskRequestManager.getByOrderId(this, this.order._id)
        this.hasContractSubTask = (subTasks || []).some(s => isAkbsSubTask(s.requestTask, AKBS_SUB_TASK.CONTRACT))
      },

      /**
       * 契約詳細入力画面（新規登録）へ
       * サブタスク画面からは別タブで開く（入力中のサブタスクを閉じないため）
       * メインタスクからは、親（RequestPost）が受注タスクを保存してから同じタブで開く（「更新」を押さなくても開始日などが保存されるように）
       */
      async toContractDetail() {
        if (!this.order._id) {
          return
        }
        // 開始日は契約開始日の初期値になる（無いと契約詳細を申請できない）。受注画面で入れてから進んでもらう
        const missing = missingStartDates(this.order)
        if (missing.length) {
          await dialogs.showErrorDialog('開始日が入っていません', `次の作業内容の開始日を入力してから、契約詳細の登録に進んでください。\n${missing.map(m => `・${m}`).join('\n')}`)
          return
        }
        const route = { name: 'AkbsContractForm', query: { requestPostId: this.order._id } }
        if (this.isTaskRequestMode) {
          window.open(this.$router.resolve(route).href, '_blank')
          return
        }
        this.$emit('toContractDetail', route)
      },

      async setOrder() {
        this.selectItemWeek = [
          { text: '月', value: '月' },
          { text: '火', value: '火' },
          { text: '水', value: '水' },
          { text: '木', value: '木' },
          { text: '金', value: '金' },
          { text: '土', value: '土' },
          { text: '日', value: '日' }
        ]

        this.selectItemMonth = [
          { text: '1月', value: '1月' },
          { text: '2月', value: '2月' },
          { text: '3月', value: '3月' },
          { text: '4月', value: '4月' },
          { text: '5月', value: '5月' },
          { text: '6月', value: '6月' },
          { text: '7月', value: '7月' },
          { text: '8月', value: '8月' },
          { text: '9月', value: '9月' },
          { text: '10月', value: '10月' },
          { text: '11月', value: '11月' },
          { text: '12月', value: '12月' },
        ]

        this.selectItemMonth2 = [
          { text: '通常通り（通常➡奇数月、簡易➡偶数月）', value: '通常通り' },
          { text: '通常と逆（通常➡偶数月、簡易➡奇数月）', value: '通常と逆' }
        ]

        this.selectCleanCountItemMonth = [
          { value: '月 1 回', text: '月 1 回' },
          { value: '月 2 回', text: '月 2 回' },
          { value: '週 1 回', text: '週 1 回' },
          { value: '週 2 回', text: '週 2 回' },
          { value: '週 3 回', text: '週 3 回' },
          { value: '週 3.5 回', text: '週 3.5 回' },
          { value: '週 4 回', text: '週 4 回' },
          { value: '週 4.5 回', text: '週 4.5 回' },
          { value: '週 5 回', text: '週 5 回' },
          { value: '週 6 回', text: '週 6 回' }
        ]

        this.selectCleanCountItemMonthMRS = [
          { value: '週 3 回', text: '週 3 回' },
          { value: '週 3.5 回', text: '週 3.5 回' },
          { value: '週 4 回', text: '週 4 回' },
          { value: '週 4.5 回', text: '週 4.5 回' },
          { value: '週 5 回', text: '週 5 回' },
          { value: '週 5.5 回', text: '週 5.5 回' },
          { value: '週 6 回', text: '週 6 回' },
          { value: '週 6.5 回', text: '週 6.5 回' },
          { value: '週 7 回', text: '週 7 回' },
        ]

        // this.selectEstimationEverydayCountItemMonth = [
        //   { value: '週 1 回', text: '週 1 回' },
        //   { value: '週 2 回', text: '週 2 回' },
        //   { value: '週 3 回', text: '週 3 回' },
        //   { value: '週 4 回', text: '週 4 回' },
        //   { value: '週 5 回', text: '週 5 回' },
        //   { value: '週 6 回', text: '週 6 回' },
        //   { value: '週 7 回', text: '週 7 回' },
        //   { value: '週 1.5 回', text: '週 1.5 回' },
        //   { value: '週 2.5 回', text: '週 2.5 回' },
        //   { value: '週 3.5 回', text: '週 3.5 回' },
        //   { value: '週 4.5 回', text: '週 4.5 回' },
        //   { value: '週 5.5 回', text: '週 5.5 回' },
        //   { value: '週 6.5 回', text: '週 6.5 回' },
        // ]

        this.selectItemCarpet = [
          { value: 'カーペット', text: 'カーペット' }
        ]

        this.regularCleanTargetAreaSelectItem = [
          { value: 'エントランス', text: 'エントランス' },
          { value: 'ロビー', text: 'ロビー' },
          { value: '廊下', text: '廊下' },
          { value: '階段', text: '階段' },
          { value: '管理室', text: '管理室' },
        ]

        this.regularCleanDescriptionWorkSelectItem = [
          { value: '洗浄のみ', text: '洗浄のみ' },
          { value: 'ワックス', text: 'ワックス' },
          { value: 'カーペット', text: 'カーペット' }
        ]

        this.workItemList = constants.SPECIALCLEAN_WORK_ITEMS

        // 区分
        // 見積もりの区分とは意味合いが違うため、変更 2023/08/02
        // 「追加変更」を「追加」と「変更」に分ける
        this.selectItemClassification = [
          { value: '1', text: '新規' },
          // { value: '2', text: '追加変更' },
          { value: '4', text: '追加' },
          { value: '5', text: '変更' },
          { value: '3', text: 'スポット' },
        ]

        this.estimationRoundPlusCategorySelectItem = [
          { value: 'ラウンドクリーンプラス', text: 'ラウンドクリーンプラス' },
          { value: 'ラウンドウォッシュプラス', text: 'ラウンドウォッシュプラス' },
          { value: 'ラウンドダブルプラス', text: 'ラウンドダブルプラス' }
        ]

        this.selectItemCommissionFlag = [
          { value: '1', text: '有'},
          { value: '0', text: '無'}
        ]

        this.selectItemMonthlyFeeFlag = [
          { value: '1', text: '有'},
          { value: '0', text: '無'}
        ]

        this.holiday = [
          { value: '1', text: 'FULL'},
          { value: '2', text: 'ゴミ出しのみ'},
          { value: '0', text: '無'},
        ]

        this.hourItems = [
          { text: '7' },
          { text: '8' },
          { text: '9' },
          { text: '10' },
          { text: '11' },
          { text: '12' },
          { text: '13' },
          { text: '14' },
          { text: '15' },
          { text: '16' },
          { text: '17' },
          { text: '18' },
          { text: '19' },
          { text: '20' },
          { text: '21' },
          { text: '22' },
          { text: '23' }
        ]

        this.minuteItems = [
          { text: '00' },
          { text: '15' },
          { text: '30' },
          { text: '45' }
        ]

        // 作業内容コードリスト取得
        await this.getWorkCode()

        // 初回作業年の選択内容
        for (let index = 0; index < 5; index++) {
          let selectYear = (new Date()).getFullYear() + index + '年'
          this.selectItemYear.push({ text: selectYear })
        }

        // 編集の場合
        if (Object.keys(this.orderData).length) {
          this.order = this.orderData
          this.templateHTML = this.orderData.template

          if (this.isTaskRequestMode || this.referenceMode) {
            // サブタスク依頼、参照モードの場合は契約日、契約終了日を年月日形式に変換
            this.dispContractDate = utils.formatDateJa(this.orderData.contractDate)
            this.dispContractEndDate = utils.formatDateJa(this.orderData.contractEndDate)
          }

          // 途中から追加になった項目（エラーになるので追加）
          this.property.forEach(p => {
            this.order[p].forEach(o => {
              if (o.workDays && !o.weekDetail) {
                o.weekDetail = {}
              }
            })
          })

        } else {
          // 新規登録
          this.order = this.createNewOrder()
          this.order.estimateNo = this.estimateData.estimateNo
          this.order.caseName = this.estimateData.buildingName + ' ' + '受注処理'
          // 物件名、物件コード
          this.order.siteName = this.mainData.siteName || ''
          this.order.siteCode = this.mainData.siteCode
          this.order.clientCode = this.mainData.clientCode
          // 区分は「スポット」のみ反映
          if (this.estimateData.classification == 3) {
            this.order.classification = [String(this.estimateData.classification)]
            // 区分によって契約終了日の初期値を入れる
            this.setContractEndDate()
          }
          // 均等請求有無判定
          this.judgeMonthlyFee()

          for (let index = 0; index < this.estimateData.details.length; index++) {
            const estimateD = this.estimateData.details[index]
            this.order.estimationDetailsCategory.push(estimateD.categoryName)

            this.setCategory(estimateD)

            let res = []

            // 防火対象物点検
            if ((estimateD.categoryCode == '27' || estimateD.categoryName.indexOf('防火対象物') != -1) && estimateD.rowspan && estimateD.rowspan > 0) {
              res = this.setObjectEstimateValue('防火対象物点検', estimateD, true)
              res.categoryCode = '27'
              this.order.orderFireObj.push(res)
            }

            // 汚水槽
            else if (estimateD.categoryName.indexOf('汚水槽') != -1 && estimateD.rowspan && estimateD.rowspan > 0) {
              res = this.setObjectEstimateValue('汚水槽清掃', estimateD, true)
              res.categoryCode = '101'
              this.order.orderSewage.push(res)
            }

            // 防火設備
            else if (estimateD.categoryName.indexOf('防火設備') != -1 && estimateD.rowspan && estimateD.rowspan > 0) {
              res = this.setObjectEstimateValue('防火設備定期検査', estimateD, true)
              res.categoryCode = '102'
              this.order.orderFireFixed.push(res)
            }

            // 連結送水管
            else if (estimateD.categoryName.indexOf('連結送水管') != -1 && estimateD.rowspan && estimateD.rowspan > 0) {
              res = this.setObjectEstimateValue('連結送水管耐圧性能点検', estimateD, true)
              res.categoryCode = '103'
              this.order.orderConnented.push(res)
            }

            // ラウンドサービス
            else if (estimateD.categoryCode == '1') {

              if (estimateD.rowspan > 0) {
                res = this.setObjectEstimateValue('ラウンドサービス', estimateD, false)
                res.count2 = []

                if(Object.keys(estimateD.subItemModalData).length && estimateD.subItemModalData.toolTip) {
                  // 清掃回数
                  res.count2 = [estimateD.subItemModalData.toolTip.清掃回数]
                  // 年末年始
                  res.newYearHolidaysRls = []
                  if (estimateD.subItemModalData.selectedValue && estimateD.subItemModalData.selectedValue[14] === '1') {
                    res.newYearHolidaysRls = estimateD.subItemModalData.newYearHoliday || []
                  }

                  // 写真報告
                  if (estimateD.subItemModalData.selectedValue && estimateD.subItemModalData.selectedValue[9]) {
                    const photoVal = estimateD.subItemModalData.selectedValue[9]
                    res.photoVal = photoVal
                    if (photoVal == '0') {
                      res.photo = 'なし'
                    } else {
                      if (photoVal.indexOf('m') > -1) {
                        res.photo = '月 ' + photoVal.replace('m', '') + ' 回'
                      } else {
                        res.photo = '週 ' + photoVal + ' 回'
                      }
                    }
                  }
                }
                this.order.orderRls.push(res)
              }
            }

            // ラウンドプラス
            else if (estimateD.categoryCode == '2') {
              if (Object.keys(estimateD.subItemModalData).length) {
                this.order.estimationDetailsCategory.push('ラウンドプラス')

                res = this.setObjectEstimateValue('ラウンドプラス', estimateD, false)
                // 清掃回数詳細
                res.count2 = estimateD.subItemModalData.toolTip.清掃回数_RLS.split(',')
                // 作業曜日・時間帯
                res.remarks = this.setRemarksVal(estimateD.subItemModalData)
                // 写真報告
                if (estimateD.subItemModalData.selectedRls && estimateD.subItemModalData.selectedRls[9]) {
                  const photoVal = estimateD.subItemModalData.selectedRls[9]
                  res.photoVal = photoVal
                  if (photoVal == '0') {
                    res.photo = 'なし'
                  } else {
                    if (photoVal.indexOf('m') > -1) {
                      res.photo = '月 ' + photoVal.replace('m', '') + ' 回'
                    } else {
                      res.photo = '週 ' + photoVal + ' 回'
                    }
                  }
                }

                if (estimateD.subItemModalData.selectedNormal) {
                  // 清掃希望階数
                  if (estimateD.subItemModalData.selectedNormal[7]) {
                    res.normalCount = ['週 ' + estimateD.subItemModalData.selectedNormal[7] + ' 回']
                  }

                  // 固定清掃の時間指定
                  if (estimateD.subItemModalData.selectedNormal[4]) {
                    res.specificTime = [estimateD.subItemModalData.selectedNormal[4]]
                  }

                  // 実働時間
                  if (res.specificTime.length) {
                    // 時間指定あり
                    if (res.specificTime[0] == '1') {
                      res.hours = Number(estimateD.subItemModalData.selectedNormal[5])
                    // 時間指定なし
                    } else {
                      res.hours = Number(estimateD.subItemModalData.selectedNormal[6])
                    }
                  }

                  // 人数（見積の固定清掃の人数は input で、古い見積は '1 人' の文字で入っているので、先頭の数字だけ読む）
                  if (estimateD.subItemModalData.selectedNormal[8]) {
                    const people = parseFloat(estimateD.subItemModalData.selectedNormal[8])
                    if (!isNaN(people)) {
                      res.people = people
                    }
                  }

                  // 祝日対応（現在、RLSプラスに祝日対応の選択肢はない）
                  if (estimateD.subItemModalData.selectedNormal[16]) {
                    res.holiday = [estimateD.subItemModalData.selectedNormal[16]]
                  }

                  // 年末年始（RLS）
                  res.newYearHolidaysRls = []
                  if (estimateD.subItemModalData.selectedRls && estimateD.subItemModalData.selectedRls[14] === '1') {
                    res.newYearHolidaysRls = estimateD.subItemModalData.newYearHolidayRls || []
                  }

                  // 年末年始（固定清掃）
                  if (estimateD.subItemModalData.selectedNormal[18]) {
                    res.newYearHoliday = [estimateD.subItemModalData.selectedNormal[18]]
                    res.newYearHolidays = []
                    if (res.newYearHoliday[0] == '1') {
                      res.newYearHolidays = estimateD.subItemModalData.newYearHoliday
                    }
                  }
                }

                // 定期清掃の作業月の初期値
                res.implementationMonth = ['通常通り']
                // 定期清掃の初回作業年、月、作業月を追加
                res.firstWorkYear = thisYear
                res.firstWorkMonth = []
                // 種別
                if (estimateD.categoryName.indexOf('クリーンプラス') > -1) {
                  res.estimationRoundPlusCategorySelect = ['ラウンドクリーンプラス']
                  // 不要なものを削除
                  delete res.firstWorkYear
                  delete res.firstWorkMonth
                  delete res.implementationMonth
                } else if (estimateD.categoryName.indexOf('ウォッシュプラス') > -1) {
                  res.estimationRoundPlusCategorySelect = ['ラウンドウォッシュプラス']
                  delete res.specificTime
                } else if (estimateD.categoryName.indexOf('ダブルプラス') > -1) {
                  res.estimationRoundPlusCategorySelect = ['ラウンドダブルプラス']
                }
                // 発注データは配列
                res.purchase = []
                // 不要なものを削除
                delete res.supplier
                delete res.orderPrice
                this.order.orderRlsPlus.push(res)
              }
            }

            // 日常清掃
            else if (estimateD.categoryCode == '3') {
              if(Object.keys(estimateD.subItemModalData).length) {
                res = this.setObjectEstimateValue('日常清掃', estimateD, false)
                res.details = this.getTabDetail(estimateD)
                // 不要なデータを削除
                delete res.dispCount
                delete res.startDate
                delete res.workDays
                delete res.weekDetail
                this.order.orderEverydays.push(res)
              }
            }

            // 管理員業務
            else if (estimateD.categoryCode == '4') {
              if(Object.keys(estimateD.subItemModalData).length) {
                res = this.setObjectEstimateValue('管理員業務', estimateD, false)
                res.details = this.getTabDetail(estimateD)
                // 不要なデータを削除
                delete res.dispCount
                delete res.startDate
                delete res.workDays
                delete res.weekDetail
                this.order.orderManagerWorks.push(res)
              }
            }

            // 定期清掃
            else if (estimateD.categoryCode == '5') {
              if (estimateD.rowspan && estimateD.rowspan > 0) {
                res = this.setObjectEstimateValue('定期清掃', estimateD, false)

                res.details = []
                // let content = []
                // let txt = []
                // let count = 0

                for (let j = 0; j < this.estimateData.details.length; j++) {
                  const detail = this.estimateData.details[j]

                  // 定期清掃年額の行以外
                  if (detail.categoryCode == '5' && detail.groupName == estimateD.groupName && detail.fixedRowspan != -1 && detail.type != 'fixedCalc') {
                    res.details.push(this.getTabDetail2(detail))
                    // 均等請求ありで、月額が反映されていない場合（定期清掃で均等請求フラグが立っていない（おそらく、ないパターン））
                    if (this.order.monthlyFeeFlag && this.order.monthlyFeeFlag.length && this.order.monthlyFeeFlag[0] == '1') {
                      if (!res.monthlyFee) {
                        res.monthlyFee = String(detail.categoryUnitPrice)
                      }
                    }
                  }
                }
                // content.push(txt.join('・'))

                // 内容と詳細を結合
                for (let k = 0; k < res.details.length; k++) {
                  const fixedD = res.details[k]
                  if (res.details.length > 1) {
                    fixedD.content = k + 1
                  } else {
                    fixedD.content = ''
                  }
                }
                this.order.orderRegular.push(res)
              }
            }

            // フロントサポート
            else if (estimateD.categoryCode == '6') {
              if (estimateD.rowspan && estimateD.rowspan > 0) {
                res = this.setObjectEstimateValue('フロントサポート', estimateD, true)
                res.count2 = []

                // 清掃回数
                if(Object.keys(estimateD.subItemModalData).length && estimateD.subItemModalData.toolTip) {
                  res.count2 = [estimateD.subItemModalData.toolTip.作業回数]
                }
                res.startDate = ''
                // 不要なデータを削除
                delete res.implementationMonth
                this.order.orderFront.push(res)
              }
            }

            // フロントサポートプラス
            else if (estimateD.categoryCode == '7') {
              if (estimateD.rowspan && estimateD.rowspan > 0) {
                res = this.setObjectEstimateValue('フロントサポートプラス', estimateD, true)
                res.count2 = []

                // 清掃回数
                if(Object.keys(estimateD.subItemModalData).length && estimateD.subItemModalData.toolTip) {
                  let c2 = '週 1 回'
                  if (estimateD.subItemModalData.selectedValue[2] == 'm1') {
                    c2 = '月 1 回'
                  }
                  res.count2 = [c2]
                }
                res.startDate = ''
                // 不要なデータを削除
                delete res.implementationMonth
                this.order.orderFrontPlus.push(res)
              }
            }

            // ラウンドトラッシュ
            else if (estimateD.categoryCode == '8') {
              if (estimateD.rowspan && estimateD.rowspan > 0) {
                res = this.setObjectEstimateValue('ラウンドトラッシュ', estimateD, false)
                res.count2 = []

                // 清掃回数
                if(Object.keys(estimateD.subItemModalData).length && estimateD.subItemModalData.toolTip) {
                  res.count2 = [estimateD.subItemModalData.toolTip.作業回数]
                }
                // 年末年始
                res.newYearHolidaysRls = []
                if (estimateD.subItemModalData.selectedValue && estimateD.subItemModalData.selectedValue[7] === '1') {
                  res.newYearHolidaysRls = estimateD.subItemModalData.newYearHoliday || []
                }
                this.order.orderRlsTrash.push(res)
              }
            }

            // クオリティレポート
            else if (estimateD.categoryCode == '9') {
              if (estimateD.rowspan && estimateD.rowspan > 0) {
                res = this.setObjectEstimateValue('クオリティレポート', estimateD, true)
                // 不要なデータを削除
                delete res.implementationMonth
                this.order.orderQuality.push(res)
              }
            }

            // ガラス清掃
            else if (estimateD.categoryCode == '10') {
              if (estimateD.rowspan && estimateD.rowspan > 0) {
                res = this.setObjectEstimateValue('ガラス清掃', estimateD, true)
                this.order.orderGlass.push(res)
              }
            }

            // 排水管清掃
            else if (estimateD.categoryCode == '11') {
              if (estimateD.rowspan && estimateD.rowspan > 0) {
                res = this.setObjectEstimateValue('排水管清掃', estimateD, true)
                this.order.orderDrain.push(res)
              }
            }

            // 貯水槽清掃
            else if (estimateD.categoryCode == '12') {
              if (estimateD.rowspan && estimateD.rowspan > 0) {
                res = this.setObjectEstimateValue('受水槽清掃', estimateD, true)
                this.order.orderWaterTank.push(res)
              }
            }

            // 植栽剪定
            else if (estimateD.categoryCode == '13') {
              if (estimateD.rowspan && estimateD.rowspan > 0) {
                res = this.setObjectEstimateValue('植栽剪定', estimateD, true)
                this.order.orderPlanting.push(res)
              }
            }

            // 特別清掃
            else if (estimateD.categoryCode == '14') {
              if (estimateD.rowspan && estimateD.rowspan > 0) {
                res = this.setObjectEstimateValue('特別清掃', estimateD, false)

                res.details = []

                let newData = estimateD.newData
                for (let j = 0; j < this.estimateData.details.length; j++) {
                  const detail = this.estimateData.details[j]

                  if (detail.categoryCode == '14' && detail.groupName == estimateD.groupName) {
                    res.details.push(this.getTabDetail3(detail, newData))
                  }
                }
                // 仕様変更後の特別清掃（見積りの単価1が結合）
                if (newData) {
                  res.unitPrice = estimateD.categoryUnitPrice
                  res.amount = estimateD.categoryAmount
                  res.newData = newData
                  res.count = estimateD.categoryQty
                  res.unit = estimateD.categoryUnitName
                  res.dispCount = estimateD.categoryQty + estimateD.categoryUnitName
                  res.workCode = this.getInitWorkCode(estimateD.itemName, '14')
                }
                this.order.orderSpecialCleans.push(res)
              }
            }

            // 消防設備点検
            else if (estimateD.categoryCode == '15') {
              if (estimateD.rowspan && estimateD.rowspan > 0) {
                res = this.setObjectEstimateValue('消防設備点検', estimateD, true)
                this.order.orderFire.push(res)
              }
            }

            // 建築設備定期検査
            else if (estimateD.categoryCode == '16') {
              if (estimateD.rowspan && estimateD.rowspan > 0) {
                res = this.setObjectEstimateValue('建築設備定期検査', estimateD, true)
                this.order.orderConstruction.push(res)
              }
            }

            // 特定建築物定期調査
            else if (estimateD.categoryCode == '17') {
              if (estimateD.rowspan && estimateD.rowspan > 0) {
                res = this.setObjectEstimateValue('特定建築物定期調査', estimateD, true)
                this.order.orderSpConstruction.push(res)
              }
            }

            // 共用部設備点検
            else if (estimateD.categoryCode == '18') {
              if (estimateD.rowspan && estimateD.rowspan > 0) {
                res = this.setObjectEstimateValue('共用部設備点検', estimateD, true)
                this.order.orderCommon.push(res)
              }
            }

            // エレベーター保守点検
            else if (estimateD.categoryCode == '19') {
              if (estimateD.rowspan && estimateD.rowspan > 0) {
                res = this.setObjectEstimateValue('エレベーター保守点検', estimateD, true)
                this.order.orderEv.push(res)
              }
            }

            // 増圧ポンプ点検
            else if (estimateD.categoryCode == '20') {
              if (estimateD.rowspan && estimateD.rowspan > 0) {
                res = this.setObjectEstimateValue('増圧ポンプ点検', estimateD, true)
                this.order.orderPress.push(res)
              }
            }

            // 給排水ポンプ点検
            else if (estimateD.categoryCode == '21') {
              if (estimateD.rowspan && estimateD.rowspan > 0) {
                res = this.setObjectEstimateValue('給排水ポンプ点検', estimateD, true)
                this.order.orderWaterSupply.push(res)
              }
            }

            // 簡易専用水道
            else if (estimateD.categoryCode == '22') {
              if (estimateD.rowspan && estimateD.rowspan > 0) {
                res = this.setObjectEstimateValue('簡易専用水道', estimateD, true)
                this.order.orderSimpleWater.push(res)
              }
            }

            // 管球対応
            else if (estimateD.categoryCode == '23') {
              if (estimateD.rowspan && estimateD.rowspan > 0) {
                res = this.setObjectEstimateValue('管球対応', estimateD, true)
                this.order.orderTube.push(res)
              }
            }

            // 粗大ごみ対応
            else if (estimateD.categoryCode == '24') {
              if (estimateD.rowspan && estimateD.rowspan > 0) {
                res = this.setObjectEstimateValue('粗大ごみ対応', estimateD, true)
                this.order.orderBulkyTrash.push(res)
              }
            }

            // 物品販売
            else if (estimateD.categoryCode == '25') {
              if (estimateD.rowspan && estimateD.rowspan > 0) {
                res = this.setObjectEstimateValue('物品販売', estimateD, true)
                this.order.orderSale.push(res)
              }
            }

            // 緊急対応
            else if (estimateD.categoryCode == '26') {
              if (estimateD.rowspan && estimateD.rowspan > 0) {
                res = this.setObjectEstimateValue('緊急対応', estimateD, true)
                this.order.orderEmergency.push(res)
              }
            }

            // スポット清掃
            else if (estimateD.categoryCode == '28') {
              if (estimateD.rowspan > 0) {
                res = this.setObjectEstimateValue(estimateD.categoryName, estimateD, true)
                res.area = ''
                res.workDetail = ''
                // res.carpet = []
                res.file = 'spotCommonFile'

                this.order.orderSpot.push(res)
              }
            }

            // MRS
            else if (estimateD.categoryCode == '29') {
              if (estimateD.rowspan > 0) {
                res = this.setObjectEstimateValue('マンションローテーションサービス（MRS）', estimateD, false)
                res.count2 = []
                res.trashCount = ''

                // 清掃回数・ゴミ搬出回数
                if(Object.keys(estimateD.subItemModalData).length && estimateD.subItemModalData.selectedValue) {
                  res.count2 = ['週 ' + estimateD.subItemModalData.selectedValue[1] + ' 回']
                  res.trashCount = this.formatMrsTrashCount(estimateD.subItemModalData.selectedValue[2])
                }
                this.order.orderMRS.push(res)
              }
            }

            // カテゴリコードがないもの
            else {
              if (estimateD.rowspan > 0) {
                res = this.setObjectEstimateValue(estimateD.categoryName, estimateD, true)
                res.file = 'otherCommonFile'
                res.categoryCode = 'none'
                this.order.orderOthers.push(res)
              }
            }
          }

          // 発注
          if (this.estimateData.purchase && this.estimateData.purchase.length) {
            for (let index = 0; index < this.estimateData.purchase.length; index++) {
              const purchase = this.estimateData.purchase[index]
              // 見積りにはないカテゴリーを先に取得
              // 防火対象物点検（途中から見積りにも追加）
              if (purchase.categoryCode == '27' || purchase.categoryName.indexOf('防火対象物') != -1) {
                this.setPurchaseValue(purchase, 'orderFireObj')
              }

              // 汚水槽
              else if (purchase.categoryName.indexOf('汚水槽') != -1) {
                this.setPurchaseValue(purchase,  'orderSewage')
              }

              // 防火設備
              else if (purchase.categoryName.indexOf('防火設備') != -1) {
                this.setPurchaseValue(purchase, 'orderFireFixed')
              }

              // 連結送水管
              else if (purchase.categoryName.indexOf('連結送水管') != -1) {
                this.setPurchaseValue(purchase, 'orderConnented')
              }

              // 以下は見積りに元からあるカテゴリー
              else if (!isNaN(purchase.categoryCode) && Number(purchase.categoryCode) >= 1 && Number(purchase.categoryCode) <= 29) {
                for (let j = 0; j < this.propertySet.length; j++) {
                  const p = this.propertySet[j]
                  if (p.code == purchase.categoryCode) {
                    this.setPurchaseValue(purchase, p.val)
                  }
                }
              }

              // カテゴリコードがないもの、もしくは例外コード
              else {
                this.setPurchaseValue(purchase, 'orderOthers')
              }
            }
          }

          // 手数料
          if (this.estimateData.commission && this.estimateData.commission.length) {
            for (let index = 0; index < this.estimateData.commission.length; index++) {
              const commission = this.estimateData.commission[index]
              // 防火対象物点検
              if (commission.categoryCode == '27' || commission.categoryName.indexOf('防火対象物') != -1) {
                this.setCommission(commission, 'orderFireObj')
              }

              // 汚水槽
              else if (commission.categoryName.indexOf('汚水槽') != -1) {
                this.setCommission(commission, 'orderSewage')
              }

              // 防火設備
              else if (commission.categoryName.indexOf('防火設備') != -1) {
                this.setCommission(commission, 'orderFireFixed')
              }

              // 連結送水管
              else if (commission.categoryName.indexOf('連結送水管') != -1) {
                this.setCommission(commission, 'orderConnented')
              }

              // 以下は元から見積りにあるカテゴリー
              else if (!isNaN(commission.categoryCode) && Number(commission.categoryCode) >= 1 && Number(commission.categoryCode) <= 29) {
                for (let j = 0; j < this.propertySet.length; j++) {
                  const p = this.propertySet[j]
                  if (p.code == commission.categoryCode) {
                    this.setCommission(commission, p.val)
                  }
                }
              }

              // カテゴリコードがないもの、もしくは例外コード
              else {
                this.setCommission(commission, 'orderOthers')
              }
            }
          }
        }

        // 新規登録の場合
        if (!this.orderData || !Object.keys(this.orderData).length) {
          // 物件情報に「物件名、住所、郵便番号、階数、戸数」が表示されるよう生成
          const info = this.createBuildingContents()
          if (info) {
            this.order.buildingName = info
          }

          // 登録のない得意先（得意先コードがない）場合にアラート
          if (!this.estimateData.clientCode) {
            const dialogsRes = await dialogs.showConfirmDialog('登録のない得意先ですか？', '新規の得意先の場合は『はい』を押してください。\nメモ欄に得意先の情報を表示します。')
            if (dialogsRes == 'YES') {
              // メモ欄に反映
              this.clientContents(this.mainData)
            }
          }
          await this.getBillingData()
        }

        // 受注仮登録、受注処理、編集の場合は親に受注データと入力チェックの結果を返却
        this.orderDataEmit()
        // 物件リスト取得
        this.$emit('getBuildingList')
      },

      /**
       * 請求先マスタから情報取得
       */
      async getBillingData() {
        if (this.order.newClient) {
          return
        }

        if (!this.order.siteCode && !this.order.clientCode) {
          // alert('物件コードなし')
          return
        }

        this.loading = true
        let siteCode = this.order.siteCode

        // 新規の時はコードなくす
        if (this.order.classification && this.order.classification[0]!='1') {
          siteCode = ''
        }
        const res = await backend.searchData('akbsTable/getBillingData', { siteCode, clientCode: this.order.clientCode })
        if (res.data.data) {
          const data = res.data.data
          for (let i = 0; i < Object.keys(data).length; i++) {
            const key = Object.keys(data)[i]
            this.order[key] = data[key]
          }
        }
        this.loading = false
      },

      /**
       * メインタスクで得意先変更
       */
      async clientSelected(code) {
        this.order.clientCode = code
        await this.getBillingData()
      },

      /**
       * 物件選択
       * @param e 選択したデータ
       */
      async siteSelected(e) {
        this.order.siteCode = e.siteCode
        this.order.siteName = e.site1 + e.site2
        await this.getBillingData()
      },

      /**
       * 建物名 change イベント
       */
      siteNameChanged() {
        if (!this.order.siteName) {
          this.order.siteCode = ''
          this.order.sentDate = ''
          this.order.closingDate = ''
          this.order.billingSentDate = ''
          this.order.sentNames = []
        }
        this.reload++
      },

      /**
       * 均等請求有無判定
       */
      judgeMonthlyFee() {
        // 均等請求の有無、初期値0にする
        this.order.monthlyFeeFlag = ['0']

        for (let i = 0; i < this.estimateData.details.length; i++) {
          const e = this.estimateData.details[i]
          // 詳細モーダルデータがある場合（日常・管理はなし）
          if (e.rowspan > -1 && e.subItemModalData && Object.keys(e.subItemModalData).length) {
            // 均等請求フラグありの場合
            if (e.subItemModalData.monthlyFeeFlag) {
              this.order.monthlyFeeFlag = ['1']
              return
            }
          }
        }
      },

      /**
       * 物件情報 生成
       */
      createBuildingContents() {
        const res = []
        const buildingName = '物件名　：' + this.estimateData.buildingName
        const code = '物件番号：'
        const team = 'チーム　：'
        const kana = 'フリガナ　：'
        let postalCode = '郵便番号：---'
        const address = '住所　　：' + this.estimateData.buildingAddress2
        let other = ''

        if (this.estimateData.buildingPostalCode && this.estimateData.buildingPostalCode != '') {
          postalCode = '郵便番号：' + this.estimateData.buildingPostalCode
        }
        if (this.estimateData.buildingInfo.stairs && this.estimateData.buildingInfo.stairs != '0') {
          other = '階数：' +  this.estimateData.buildingInfo.stairs
        }
        if (this.estimateData.buildingInfo.basement && this.estimateData.buildingInfo.basement != '0') {
          other += '　地下：' + this.estimateData.buildingInfo.basement
        }
        if (this.estimateData.buildingInfo.households && this.estimateData.buildingInfo.households != '0') {
          other += '　戸数：' + this.estimateData.buildingInfo.households
        }

        // 新規の場合
      // if (this.order.classification[0] == '1') {
        // 対象の得意先の場合、物件番号を入れる
        if (utils.includesTxt(this.mainData.clientName, siteCodeForNewSite)) {
          res.push(code)
        }
        // 既存に無い得意先で、対象の得意先の場合、チームを入れる
        if (!this.estimateData.clientCode && this.mainData.clientName.indexOf('東急住宅') == -1 && utils.includesTxt(this.mainData.clientName, teamForNewSite)) {
          res.push(team)
        }
      // }

        res.push(buildingName)

        // 新規の場合
        // if (this.order.classification[0] == '1') {
        // カナを入れる
        res.push(kana)
        // }

        res.push(postalCode)
        res.push(address)
        res.push(other)
        return res.join('\n')
      },

      /**
       * 更新の際の物件情報更新
       */
      updateBuildingContents() {
        // 更新の場合
        if (this.orderData && Object.keys(this.orderData).length) {
          // 区分が選択されている場合
          if (this.order.classification.length) {
            // 既存の物件情報が何もない場合
            if (!this.order.buildingName) {
              this.order.buildingName = this.createBuildingContents()
            }
            const newInfo = this.createBuildingContents()
            // 現在の物件情報を1行ごとに配列
            const oldRow = this.order.buildingName.split('\n')

            // 新規物件の変更した場合
            if (this.classification == '1') {
              // 物件番号が必要な場合
              if (newInfo.indexOf('物件番号') > -1) {
                // 既存に物件番号がない場合
                if (this.order.buildingName.indexOf('物件番号') == -1) {
                  // 物件番号を追加
                  this.order.buildingName = '物件番号：\n' + this.order.buildingName
                }
              }

              // チームが必要な場合
              if (newInfo.indexOf('チーム') > -1) {
                // 既存にチームがない場合
                if (this.order.buildingName.indexOf('チーム') == -1) {
                  // 物件名の前に追加
                  const str1 = this.order.buildingName.slice(0, this.order.buildingName.indexOf('物件名'))
                  const str2 = this.order.buildingName.slice(this.order.buildingName.indexOf('物件名'))
                  this.order.buildingName = str1 + 'チーム：\n' + str2
                }
              }

              // 既存にカナがない場合
              if (this.order.buildingName.indexOf('フリガナ') == -1) {
                // 郵便番号の前に追加
                  const str1 = this.order.buildingName.slice(0, this.order.buildingName.indexOf('郵便番号'))
                  const str2 = this.order.buildingName.slice(this.order.buildingName.indexOf('郵便番号'))
                  this.order.buildingName = str1 + 'フリガナ：\n' + str2
              }
            // 新規物件以外の場合、不要な項目を削除
            } else {
              let info = []
              for (let i = 0; i < oldRow.length; i++) {
                const row = oldRow[i]
                if ((row.indexOf('物件番号：') == -1 && row.indexOf('物件番号:') == -1) && (row.indexOf('チーム：') == -1 && row.indexOf('チーム:') == -1) && (row.indexOf('フリガナ：') == -1 && row.indexOf('フリガナ:') == -1)) {
                  info.push(row)
                }
              }
              this.order.buildingName = info.join('\n')
            }
          }
        }
      },

      /**
       * 新規得意先のための情報
       */
      clientContents(main) {
        // 新規得意先フラグ
        this.order.newClient = true

        let client = []
        if (main.clientName.indexOf('　') > -1) {
          client = main.clientName.split('　')
        } else {
          client = main.clientName.split(' ')
        }
        let name = main.clientName
        if (client && client.length && client[0]) {
          name = client[0]
        }
        let branch = ''
        if (client && client.length && client[1]) {
          branch = client[1]
        }

        let res =
          '--得意先情報--\n'
          + '社名：' + name + '\n'
          + 'フリガナ：\n'
          + '支店：' + branch + '\n'
          + '郵便番号：' + this.estimateData.clientPostalCode + '\n'
          + '住所：' + (this.estimateData.clientAddress1 || '') + '\n'
          + 'TEL：' + this.estimateData.clientPhoneNumber + '\n'
          + 'FAX：' + this.estimateData.clientFax + '\n'
          + '--------------'

        this.order.orderMemo = res
      },

      deleteClientContents() {
        // 新規得意先フラグ
        this.order.newClient = false

        if (this.order.orderMemo && this.order.orderMemo.indexOf('--得意先情報') > -1) {
          let memo = this.order.orderMemo
          let str1 = memo.slice(0, memo.indexOf('--得意先情報'))
          let str2 = memo.slice(memo.indexOf('--------------') + 14)
          this.order.orderMemo = str1 + str2
        }
      },

      /**
       * 見積明細カテゴリーセット
       */
      setCategory(estimateD) {
        let code = estimateD.categoryCode
        if (estimateD.categoryName.indexOf('汚水槽') > -1) {
          code = '101'
        } else if (estimateD.categoryName.indexOf('防火設備') > -1) {
          code = '102'
        } else if (estimateD.categoryName.indexOf('連結送水管') > -1) {
          code = '103'
        } else if (estimateD.categoryName.indexOf('防火対象物') > -1) {
          code = '27'
        } else if (!estimateD.categoryCode || estimateD.categoryCode == '' || isNaN(estimateD.categoryCode)) {
          code = 'none'
        }
        this.order.estimationDetailsCategoryCode.push(code)

        // セルが結合しているものと判定する必要があるため、groupnameはgroupname+カテゴリコードとする
        this.order.categoryName.push({ name: estimateD.categoryName, groupName: estimateD.groupName + code})
      },

      /**
       * 基本情報を見積から取得
       * @param estimate 見積データ
       * @param firstWorkMonth 作業開始月の有無
       */
      setObjectEstimateValue(name, estimate, firstWorkMonth) {
        let res
        if ((name == '定期清掃' && estimate.categoryCode == '5') || (name == '特別清掃' && estimate.categoryCode == '14')) {
          res = {
            name,
            categoryCode: estimate.categoryCode,
            groupName: estimate.groupName,
            monthlyFee: this.getMonthlyFee(estimate.subItemModalData, estimate.categoryUnitPrice),
            supplier: '',
            orderPrice: '',
            commissionFlag: [],
            commissionPrice: '---',
            memo: ''
          }
          if (name == '定期清掃') {
            res.workCode = this.getInitWorkCode(estimate.categoryName, estimate.categoryCode)
          }
          return res
        } else {
          res = {
            name,
            content: estimate.categoryName,
            categoryCode: estimate.categoryCode,
            count: estimate.categoryQty,
            unit: estimate.categoryUnitName,
            dispCount: estimate.categoryQty + estimate.categoryUnitName,
            unitPrice: estimate.categoryUnitPrice,
            amount: estimate.categoryAmount,
            monthlyFee: this.getMonthlyFee(estimate.subItemModalData, estimate.categoryUnitPrice),
            groupName: estimate.groupName,
            supplier: '',
            orderPrice: '',
            commissionFlag: [],
            commissionPrice: '---',
            memo: '',
            workCode: this.getInitWorkCode(estimate.categoryName, estimate.categoryCode)
          }

          // 作業月が必要な場合
          if (firstWorkMonth) {
            let add = {
              // 初回年
              firstWorkYear: thisYear,
              // 初回月
              firstWorkMonth: [],
              // 実施月
              implementationMonth: [],
            }
            res = {...res, ...add}

          // 作業月ではない場合
          } else {
            let add = {
              // 開始日
              startDate: '',
              // 作業曜日
              workDays: [],
              // 毎週・第何週
              weekDetail: {}
            }
            res = {...res, ...add}
          }
        }

        return res
      },

      /**
       * 月額料金取得
       * @param e 対象見積りデータ
       * @param categoryUnitPrice 受注単価
       */
      getMonthlyFee(e, categoryUnitPrice) {
        // 均等請求の場合
        if (this.order.monthlyFeeFlag && this.order.monthlyFeeFlag.length && this.order.monthlyFeeFlag[0] == '1') {
          // フラグが立っている場合
          if (e.monthlyFeeFlag) {
            return String(e.monthlyFee)
          } else {
            // 受注単価を表示
            return String(categoryUnitPrice)
          }
        } else {
          return ''
        }
      },

      /**
       * 日常・管理のタブ内で生成された見積もりデータを取得
       */
      getTabDetail(estimate) {
        let res = []
        for (let i = 0; i < estimate.subItemModalData.modalTabData.length; i++) {
          const m = estimate.subItemModalData.modalTabData[i]
          // console.log(m.data)
          // 作業曜日、作業時間帯
          let remarks = this.setRemarksVal(m.data)

          let count2 = []
          let specificTime = []
          let hours = null
          let people = null
          let holiday = []
          let newYearHoliday = []
          let newYearHolidays = []

          if (m.data && m.data.selectedValue) {
            // 詳細清掃回数
            if (m.data.selectedValue[7]) {
              let val = m.data.selectedValue[7]
              val = '週 ' + val + ' 回'
              count2 = [val]

              if (m.data.conf && m.data.conf.dispTimes) {
                val = '週 ' + m.data.conf.dispTimes + ' 回'
                count2 = [val]
              }
            }

            // 時間指定の有無取得
            if (m.data.selectedValue[4]) {
              specificTime = [m.data.selectedValue[4]]
            }

            // 実働時間
            if (specificTime.length) {
              // 時間指定あり
              if (specificTime[0] == '1') {
                hours = Number(m.data.selectedValue[5])
              // 時間指定なし
              } else {
                hours = Number(m.data.selectedValue[6])
              }

              if (m.data.conf && m.data.conf.dispHours) {
                hours = Number(m.data.conf.dispHours)
              }
            }

            // 人数
            if (m.data.selectedValue[8]) {
              people = Number(m.data.selectedValue[8])

              if (m.data.conf && m.data.conf.dispPeople) {
                people = Number(m.data.conf.dispPeople)
              }
            }

            // 祝日対応
            if (m.data.selectedValue[16]) {
              holiday = [m.data.selectedValue[16]]
            }

            // 年末年始
            if (m.data.selectedValue[18]) {
              newYearHoliday = [m.data.selectedValue[18]]
              if (newYearHoliday[0] == '1') {
                newYearHolidays = m.data.newYearHoliday
              }
            }
          }

          res.push(
            {
              remarks,
              count2,
              startDate: '',
              id: m.id,
              content: '',
              specificTime,
              hours,
              people,
              holiday,
              newYearHoliday,
              newYearHolidays
            }
          )
        }

        for (let j = 0; j < estimate.subItemModalData.display.length; j++) {
          const d = estimate.subItemModalData.display[j]
          for (let k = 0; k < res.length; k++) {
            const r = res[k]
            if (d.type.indexOf(r.id) != -1) {
              r.content = d.name
              break
            }
          }
        }
        // console.log(res)
        return res
      },

      /**
       * 定期のタブ内で生成された分、データを生成
       */
      getTabDetail2(estimate) {
        let res =
          {
            count: estimate.categoryQty,
            unit: estimate.categoryUnitName,
            dispCount: estimate.categoryQty + estimate.categoryUnitName,
            unitPrice: estimate.categoryUnitPrice,
            amount: estimate.categoryAmount,
            // 初回年
            firstWorkYear: thisYear,
            // 初回月
            firstWorkMonth: [],
            // 実施月
            implementationMonth: [],
            // 対象箇所
            area: '',
            // 作業内容
            workDetail: '',
            // カーペット
            // carpet: [],
            // type
            type: estimate.type,
            // 内容名
            content: ''
          }
        // console.log(res)
        return res
      },

      /**
       * 特別清掃のデータ生成
       */
      getTabDetail3 (estimate, newData) {
        // 該当の作業項目を取得
        let workItem = null
        for (let index = 0; index < this.workItemList.length; index++) {
          if (estimate.itemName != '') {
            if(estimate.itemName.indexOf(this.workItemList[index].value) > -1){
              workItem = this.workItemList[index].id
              break
            }
          }
        }
        let res =
          {
            // 初回年
            firstWorkYear: thisYear,
            // 初回月
            firstWorkMonth: [],
            // 実施月
            implementationMonth: [],
            // 見積もりの内容（項目名）
            content: estimate.itemName,
            // 作業項目コード
            workItem,
          }
          // 仕様変更前の特別清掃の場合（見積りの単価1が結合されていない）
          if (!newData) {
            res.unitPrice = estimate.categoryUnitPrice
            res.amount = estimate.categoryAmount
            res.count = estimate.categoryQty
            res.unit = estimate.categoryUnitName
            res.dispCount = estimate.categoryQty + estimate.categoryUnitName
            res.workCode = this.getInitWorkCode(estimate.itemName, estimate.categoryCode)
          } else {
            res.newData = newData
            res.rowspan = estimate.rowspan
          }
        // console.log(res)

        // 調整費の場合、画面には表示しないが、発注書でのrowspan調整のため残す
        if (estimate.itemName == '調整費') {
          // 不要なものを削除
          delete res.firstWorkYear
          delete res.firstWorkMonth
          delete res.implementationMonth
          delete res.workItem
        }
        return res
      },

      /**
       * 発注をセット
       * @param purchase 対象発注データ
       * @param s 発注先
       * @param p 発注金額
       */
      setPurchaseValue(purchase, tar) {
        for (let i = 0; i < this.order[tar].length; i++) {
          const o = this.order[tar][i]
          if (o.groupName == purchase.groupName) {
            // RLSプラスの場合
            if (['orderRlsPlus'].includes(tar)) {
              let res = {}
              res.typeName = ''
              if (purchase.typeName) {
                res.typeName = purchase.typeName
              }
              res.supplier = purchase.supplier
              res.price = purchase.price
              res.groupName = purchase.groupName

              o.purchase.push(res)

            // 定期・特別の場合
            } else if (['orderRegular', 'orderSpecialCleans'].includes(tar)) {
              o.supplier = purchase.supplier
              o.orderPrice = purchase.price
              // 発注率追加
              o.purchaseRate = purchase.rate

            } else {
              o.supplier = purchase.supplier
              o.orderPrice = purchase.price
            }
            break
          }
        }
      },

      /**
       * 手数料をセット
       * @param commission 手数料データ
       * @param tar 対象プロパティー
       */
      setCommission(commission, tar) {
        for (let i = 0; i < this.order[tar].length; i++) {
          const o = this.order[tar][i]
          if (o.groupName == commission.groupName) {
            this.setArrayCommissionValue(commission, o, tar)
            break
          }
        }
      },

      /**
       * 配列プロパティの手数料をセット
       * @param commission 対象手数料データ
       * @param category 対象カテゴリー
       */
      setArrayCommissionValue(commission, category, tar) {
        if (commission.commissionPrice && commission.commissionPrice != '0') {
          // 手数料金額が空か0でなければ、手数料有
          category.commissionFlag = ['1']
          // 手数料金額
          category.commissionPrice = commission.commissionPrice
        } else {
          // それ以外は手数料無
          category.commissionFlag = ['0']
          // 手数料金額
          category.commissionPrice = '0'
        }

        // 定期・特別の場合
        if (['orderRegular', 'orderSpecialCleans'].includes(tar)) {
          // 手数料率追加
          category.commissionRate = commission.rate
        }
      },

      storeOriginal() {
        const tempOrder = utils.clone(this.order)
        this.originalOrder = tempOrder
      },

      /**
       * 新規受注 生成
       */
      createNewOrder() {
        return orderManager.createNewOrderModel()
      },

      /**
       * 見積参照
       */
      referenceEstimate() {
        let resolvedRoute = this.$router.resolve({
          name: 'EstimateView',
          query: {
            estimateNo: this.order.estimateNo
          }
        });
        window.open(resolvedRoute.href, '_blank');
      },

      /**
       * 作業曜日、時間 削除ボタン
       * @param tar 対象データ
       * @param idx インデックス
       */
      removeWorkRemarks(tar, idx) {
        // 全部消したら空の1行を足す。消した行が古い形なら古い形で（1つの受注の中で形を混ぜない）
        const wasOldShape = !!tar[idx] && !isDaysRemark(tar[idx])
        tar.splice(idx, 1)
        if (!tar || !tar.length) {
          this.addWorkRemarks(tar, wasOldShape)
        }
      },

      /**
       * 作業曜日、時間 追加ボタン
       * 既にある行が「行に時間が1組」の古い形なら、同じ形で足す（1つの受注の中で形を混ぜない。過去の受注はそのまま）
       * @param {Array} tar 作業曜日・時間の配列
       * @param {Boolean} oldShape 古い形で足す（配列が空のときに、消した行の形を引き継ぐ）
       */
      addWorkRemarks(tar, oldShape) {
        const last = tar && tar.length ? tar[tar.length - 1] : null
        if ((last && !isDaysRemark(last)) || (!last && oldShape)) {
          tar.push({
            workDays: [],
            weekDetail: {},
            startTime: '',
            endTime: '',
            hours: 0
          })
          return
        }
        tar.push(blankDaysRemark())
      },

      /**
       * 作業曜日・時間の行が曜日ごとの形か（画面の分岐に使う）
       */
      isDaysRemark(remark) {
        return isDaysRemark(remark)
      },

      /**
       * 作業曜日、時間をセット
       */
      setRemarksVal(data) {
        let res = []
        let attendanceType = utils.clone(constants.ATTENDANCE_TYPES)
        for (let i = 0; i < attendanceType.length; i++) {
          const a = attendanceType[i]
          a.text = a.text.replace('第', '').replace('週', '').trim()
        }
        // 見積データにremarksがある場合
        if (data.remarks && (data.remarks.length > 0 || Object.keys(data.remarks).length > 0)) {
          let remarks = data.remarks
          if (Array.isArray(remarks)) {
            // remarksが配列の場合
            for (let index = 0; index < remarks.length; index++) {
                const r = remarks[index]
                const breakTimes = utils.getTimes(r.breakHour, r.breakMinutes)
                // 曜日ごとの形で持つ（契約詳細入力画面と同じ。見積の行は時間が1組なので、選んだ曜日ぜんぶに同じ時間を入れる。勤務形態は曜日の並びどおり r.weekDetail[i]）
                // 休憩は持たない（契約書の「休憩時間１時間含む」は時間帯の幅から出していて、受注の休憩はどこも読んでいない）
                res.push(daysRemarkFromEstimate(r, Number(BigNumber(utils.getHours(r.start, r.end)).minus(breakTimes))))
            }
          } else {
              res.push(daysRemarkFromEstimate({ week: remarks.week, weekDetail: [], start: remarks.start, end: remarks.end }, utils.getHours(remarks.start, remarks.end)))
          }
        } else {
          // 見積データにremarksがない場合は、配列に初期値で1つ要素をセット
          res.push(blankDaysRemark())
        }
        return res
      },

      /**
       * 実施月の割り当て
       */
      workMonthAutoInput(firstWorkMonth, cleanCount, val) {
        // 清掃希望回数を文字列から数値型に変換
        let count = Number(cleanCount)
        // 初回作業月を配列から文字列に変換
        let monthStr = firstWorkMonth.join()
        // 文字列に変換した初回作業月を数字のみに変換
        const regex = /[^0-9]/g
        const result = monthStr.replace(regex, "")
        const month = parseInt(result)
        // 割り当て月間隔
        let monthlyInterval = 12 / count
        if (Number.isInteger(monthlyInterval)) {
          let resultMonth = []
          for (let index = 1; index <= count; index++) {
            let total
            total = ( month + (monthlyInterval * (index-1)) ) % 12
            if (total == 0) {
              resultMonth.push('12月')
            } else {
              resultMonth.push(String(total) + '月')
            }

          }
          return resultMonth
        } else {
          return val
        }
      },

      /**
       * 添付ファイル
       */
      attachmentChange(targetAttachmentName, attachmentInfo) {
        if (!this.order[targetAttachmentName]) {
          this.order[targetAttachmentName] = orderManager.createEmptyAttachment()
        }
        if (attachmentInfo) {
          this.order[targetAttachmentName].originalName = attachmentInfo.filename
          this.order[targetAttachmentName].content = attachmentInfo.content
        } else {
          this.order[targetAttachmentName] = orderManager.createEmptyAttachment()
        }
      },

      /**
       * 配信用テンプレート 変更
       */
      templateChange({html}) {
        this.templateHTML = html
        this.order.template = this.templateHTML
      },

      /**
       * 配信用テンプレート更新
       */
      async setTemplateHTL() {
        const res = await this.getTempText()
        this.templateHTML = res.templateHTML
        this.order.template = this.templateHTML
        this.order.tempBypur = res.tempBypur
      },

      /**
       * 配信用テンプレート、メールの【内容】部分を生成
       */
      async getTempText() {
        const od = this.order
        const rp = this.mainData

        // 配信用テンプレート
        let temp = []
        // 共通部分
        let common1 = []
        let common2 = []

        common1.push('いつも大変お世話になっております。')
        common1.push('')

        // お客様ご担当者様
        let cpn = rp.clientPersonName
        if (cpn && cpn.indexOf('様') == -1) {
          cpn += ' 様'
        }

        let client = utils.zenkaku(rp.clientName) + ' 様'

        common1.push(client + 'より')

        let type = ''
        if (this.order.classification.length) {
          if (this.order.classification[0] == '1') {
            type = '新規発注の'
          } else if (this.order.classification[0] == '4') {
            type = '以下、追加の'
          } else if (this.order.classification[0] == '5') {
            type = '以下、変更の'
          } else if (this.order.classification[0] == '3') {
            type = '新規発注の'
          }
        }
        common1.push(type + 'ご連絡を頂きました。')
        common1.push('恐れ入りますがご手配の程よろしくお願いいたします。')
        common1.push('')
        common1.push('【物件情報】')

        // 物件情報
        if (od.buildingName) {
          const site = od.buildingName.split('\n')
          const site2 = []
          if (site && site.length) {
            // 先頭にスペースを入れる
            site.forEach(st => {
              site2.push('　' + st)
            })
          }
          common1 = common1.concat(site2)
        }

        common1.push('')
        common1.push('【内容】')

        // 見積りの順番で反映
        let num = 0
        // 発注先ごとにデータを生成
        const byPur = {}
        for (let i = 0; i < this.estimateData.details.length; i++) {
          const e = this.estimateData.details[i]
          if (e.rowspan > 0) {
            for (let j = 0; j < PROP.length; j++) {
              const p = PROP[j]
              if (this.order[p]) {
                for (let k = 0; k < this.order[p].length; k++) {
                  const o = this.order[p][k]
                  // 受注にデータがある場合
                  if (e.groupName == o.groupName) {
                    // 発注先名
                    let pur = ''
                    // 特別清掃の詳細項目
                    let specialCleanItemArr = []
                    let specialCleanItemSt = ''

                    num++

                    let sircleNum = utils.toCircled(num)
                    // 特別清掃の場合
                    if (e.categoryCode == '14') {
                      if (o.details) {
                        specialCleanItemArr = o.details.map((sp) => {
                          return sp.content
                        })
                      }
                      if (specialCleanItemArr.length) {
                        specialCleanItemSt = `（${specialCleanItemArr.join('、')}）`
                      }
                    }
                    // カテゴリー名
                    temp.push(sircleNum + e.categoryName + specialCleanItemSt)

                    // 発注先
                    if (o.supplier) {
                      pur = o.supplier
                      temp.push('　発注先　：' + o.supplier)

                    // 発注先がなく、purchaseがある（RLSプラス）
                    } else if (o.purchase) {
                      temp = this.setPlusTemplateDetail(o.purchase, temp, byPur, o, e, num)
                    }

                    // 同じ発注先がない場合
                    if (pur && !byPur[pur]) {
                      byPur[pur] = []
                    }
                    if (pur) {
                      byPur[pur].push('●' + e.categoryName + specialCleanItemSt)
                    }

                    // 発注額
                    if (o.orderPrice) {
                      let price = '　発注額　：' + utils.numberToLocale(o.orderPrice) + '円'
                      temp.push(price)

                      if (pur) {
                        byPur[pur].push(price)
                      }
                    }

                    // 日常・管理の曜日
                    if (['3', '4'].includes(e.categoryCode)) {
                      temp = this.getWeek(o.details, temp, byPur[pur])
                    }

                    // detailsがあるもの
                    if (o.details) {
                      let detailNum = 0
                      for (let l = 0; l < o.details.length; l++) {
                        const d = o.details[l]
                        // 調整費の場合は表示しない
                        if (d.content.indexOf('調整費') > -1) {
                          continue
                        }
                        if (d.content) {
                          detailNum++

                          let mark = '※'
                          if (['3', '4'].includes(e.categoryCode)) {
                            temp.push('')
                            byPur[pur].push('')
                            mark = '　' + `(${detailNum}) `

                            temp.push(mark + this.deleteMonthlyFee(d.content))
                            byPur[pur].push(mark + this.deleteMonthlyFee(d.content).replace('\r\n', ' '))

                          // 特別清掃の場合
                          } else if (e.categoryCode == '14') {
                            // 項目が2つ以上の場合のみ項目名を挿入
                            if (specialCleanItemArr.length >= 2) {
                              temp.push(mark + this.deleteMonthlyFee(d.content))
                              byPur[pur].push(mark + this.deleteMonthlyFee(d.content).replace('\r\n', ' '))
                            }
                          }
                        }
                        if (o.dispCount) {
                          let val = '　回　数　：' + o.dispCount
                          temp.push(val)

                          if (pur) {
                            byPur[pur].push(val)
                          }
                        }
                        let val = this.setTemplateDetail(d, temp, e.categoryCode, e)
                        temp = val.temp

                        if (pur) {
                          if (val.count) {
                            byPur[pur].push(val.count)
                          }
                          if (val.holiday) {
                            byPur[pur].push(val.holiday)
                          }
                          if (val.week1) {
                            byPur[pur].push(val.week1)
                          }
                          if (val.month1) {
                            byPur[pur].push(val.month1)
                          }
                          if (val.start) {
                            byPur[pur].push(val.start)
                          }
                          byPur[pur].push(...val.ny)
                          byPur[pur].push(...val.extra)
                        }
                      }
                    } else {
                      // purがあるもの、つまりRLSプラス以外全て
                      if (pur) {
                        let val = this.setTemplateDetail(o, temp, e.categoryCode, e)
                        temp = val.temp
                        if (val.count) {
                          byPur[pur].push(val.count)
                        }
                        if (val.trash) {
                          byPur[pur].push(val.trash)
                        }
                        if (val.week1) {
                          byPur[pur].push(val.week1)
                        }
                        if (val.month1) {
                          byPur[pur].push(val.month1)
                        }
                        if (val.start) {
                          byPur[pur].push(val.start)
                        }
                        byPur[pur].push(...val.ny)
                        byPur[pur].push(...val.extra)
                      }
                    }
                    // RLS、MRS
                    if (['1', '29'].includes(e.categoryCode)) {
                      const rlsMsg = this.getRlsMsg(e)
                      temp.push(rlsMsg.val)
                      temp.push(rlsMsg.val2)

                      // 発注先ごとの場合は、val1のみ
                      if (pur) {
                        byPur[pur].push(rlsMsg.val)
                      }
                    }

                    // 改行挿入
                    if (e.categoryCode != '2') {
                      temp.push('')
                    }
                    if (pur) {
                      byPur[pur].push('')
                    }
                  }
                }
              }
            }
          }
        }

        // 得意先
        common2.push('【得意先】')
        common2.push('　' + utils.zenkaku(this.estimateData.clientName))
        common2.push('　' + (this.estimateData.clientAddress1 || '') + ' ' + (this.estimateData.clientAddress2 || ''))
        common2.push('　TEL：' + this.estimateData.clientPhoneNumber)
        common2.push('　FAX：' + this.estimateData.clientFax)
        common2.push('')
        common2.push('【担当者】')
        common2.push('　' + cpn)
        common2.push('　' + rp.clientMail)

        // 配信用テンプレート（全て）
        let templateHTML = ''
        // 配信用テンプレート（発注先ごと）
        let tempBypur = {}

        // 配信用テンプレート（全て）
        temp = common1.concat(temp).concat(common2)

        if (temp && temp.length) {
          templateHTML = temp.join('<br>')
        }

        // 配信用テンプレート（発注先ごと）
        if (byPur && Object.keys(byPur).length) {
          for (let i = 0; i < Object.keys(byPur).length; i++) {
            const bp = Object.keys(byPur)[i]
            let tbp = common1.concat(byPur[bp]).concat(common2)
            tempBypur[bp] = bp + ' 御中\r\n\r\n' + tbp.join('\r\n')
          }
        }

        return { templateHTML, tempBypur }
      },

      /**
       * RLS関連用の文言を生成
       */
      getRlsMsg(e) {
        let val = '※週1回灯具点灯確認・月次目視点検含みます。'
        let val2 = '※作業担当者・作業曜日・初回作業日をご連絡頂きます様お願いいたします。'

        // RLS、RLSプラスの場合は、見積りの特記事項と同条件で表示・非表示を判断する
        if (['1', '2'].includes(e.categoryCode)) {
          let cleaningTimes = ''
          let cheking = ''

          if (e.categoryCode == '1') {
            cleaningTimes = e.subItemModalData.selectedValue[2]
            cheking = e.subItemModalData.selectedValue[4]
          } else {
            cleaningTimes = e.subItemModalData.selectedRls[2]
            cheking = e.subItemModalData.selectedRls[4]
          }

          // 週1もしくは2
          if (['1', '2'].includes(cleaningTimes)) {
            // 目視含まない場合
            if (cheking == '0') {
              val = ' ※週1回灯具点灯確認含みます。'
            }
          // 月1もしくは月2
          } else if (['m1', 'm2'].includes(cleaningTimes)) {
            val = val.replace('週1回','')
            // 目視含まない場合
            if (cheking == '0') {
              val = ' ※灯具点灯確認含みます。'
            }
          }
        }
        return { val, val2 }
      },

      /**
       * 文言から月額を省く
       * @param name 対象文言
       */
      deleteMonthlyFee(name) {
        if (name && name.indexOf('月額') > -1) {
          let res = name.split('月額')
          if (res && res[0]) {
            return res[0].trim()
          }
        }
        return name
      },

      /**
       * 配信テンプレートの回数、初回、実施月などを生成
       * @param o 受注データ
       * @param temp テンプレート内容
       * @param categoryCode カテゴリコード
       * @param e 見積りデータ
       */
      setTemplateDetail(o, temp, categoryCode, e) {
        // 回数（RLSプラス・日常・管理以外）
        let count = ''
        if (!['2', '3', '4'].includes(categoryCode)) {
          // 清掃希望回数(週●回)があるもの
          if (o.count2 && o.count2.length) {
            count = o.count2[0]
          // なければ、普通の回数
          } else if (o.dispCount) {
            count = o.dispCount
          }
          if (count) {
            count = '　回　数　：' + count
            temp.push(count)
          }
        }

        // RLSのゴミ出し
        let trash = ''
        if (e.categoryCode == '1') {
          trash = '　ゴミ出し：'
          const trashVal = e.subItemModalData.selectedValue[3]
          if (trashVal == '0') {
            trash += 'なし'
          } else {
            trash += `週 ${trashVal} 回`
          }
          temp.push(trash)

        // MRSのゴミ出し
        } else if (e.categoryCode == '29') {
          trash = '　ゴミ出し：'
          const trashVal = e.subItemModalData.selectedValue[2]
          if (trashVal == '0') {
            trash += 'なし'
          } else {
            trash += `週 ${trashVal} 回`
          }
          temp.push(trash)
        }

        // 日常、管理員は見積りのタブ（1行＝1人）と受注のdetailsの行をidで結び付ける
        let tab = null
        if (['3', '4'].includes(categoryCode) && e.subItemModalData.modalTabData) {
          tab = e.subItemModalData.modalTabData.find((t) => t.id == o.id) || null
        }

        // 日常、管理員の祝日対応
        let holiday = ''
        if (tab) {
          const holiVal = tab.data.selectedValue[16]
          holiday = '　祝日対応：'
          if (holiVal == '1') {
            holiday += 'FULL'
          } else if (holiVal == '2') {
            holiday += 'ゴミ出しのみ'
          } else {
            holiday += 'なし'
          }
          temp.push(holiday)
        }

        let week1 = ''
        let month1 = ''
        // 作業曜日
        if (o.workDays) {
          week1 = '　作業曜日：'
          // 曜日を並べ替え
          let week = this.sortItem(o.workDays, 'week')
          if (week && week.length) {
            week1 += week.join('・') + this.getWeekDetails(o)
          }

          temp.push(week1)
        // 実施月
        } else if (o.implementationMonth) {
          month1 = '　実施月　：'
          // 月を並べ替え
          let month = this.sortItem(o.implementationMonth, 'month')
          if (month && month.length) {
            month1 += month.join('・') + '月'
          }
          temp.push(month1)
        }

        // 初回
        let start = ''
        // 開始日がある場合
        if (o.startDate) {
          start = moment(o.startDate).format('YYYY年M月D日')
        // 初回年月がある場合
        } else if (o.firstWorkYear || o.firstWorkMonth) {
          start = o.firstWorkYear
          if (o.firstWorkMonth[0]) {
            start += o.firstWorkMonth[0]
          }
        }
        start = '　初回作業：' + start
        temp.push(start)

        // 見積りの詳細モーダルで選んだ値（RLS は見積り1行、日常・管理はタブ）
        let selectedValue = null
        let conf = null
        if (categoryCode == '1' && e.subItemModalData) {
          selectedValue = e.subItemModalData.selectedValue
        } else if (tab) {
          selectedValue = tab.data.selectedValue
          conf = tab.data.conf
        }

        // 年末年始がある場合、もしくは三井不動産様
        let mitsui = ''
        if (this.isMitsui) {
          mitsui = '（三井不動産様は、12/30は勤務日です）'
        }
        const ny = []
        if (o.newYearHolidaysRls && (o.newYearHolidaysRls.length || this.isMitsui)) {
          ny.push('　年末年始：' + this.getNewYearDays(o.newYearHolidaysRls) + mitsui)
        }
        if (o.newYearHolidays && (o.newYearHolidays.length || this.isMitsui)) {
          ny.push('　年末年始：' + this.getNewYearDays(o.newYearHolidays) + mitsui)
        }
        // 日付が無ければ、見積りで「なし」にしているときだけ同じ位置に「なし」を出す
        if (!ny.length) {
          const none = this.getNewYearNone(selectedValue, categoryCode)
          if (none) {
            ny.push(none)
          }
        }
        temp.push(...ny)

        // 見積りの詳細モーダルで選んだ作業内容のうち、上の行に無い項目
        const extra = this.getSubItemLines(selectedValue, categoryCode, conf)
        temp.push(...extra)

        return { temp, count, trash, holiday, week1, month1, start, ny, extra }
      },

      /**
       * 見積りの詳細モーダルで選んだ内容を配信用テンプレートの行にする
       * 単価を決めるだけの項目（協力費・竣工・オーナー契約・エリアなど）は発注先に見せないので出さない
       * 清掃回数・ゴミ出し・祝日対応・年末年始は既存の行で出しているので含めない（年末年始の「なし」は getNewYearNone）
       * @param selectedValue 詳細モーダルで選んだ値
       * @param categoryCode カテゴリコード
       * @param conf 係数（日常・管理で手入力した時間・人数）
       */
      getSubItemLines(selectedValue, categoryCode, conf) {
        const lines = []
        if (!selectedValue || !selectedValue.length) {
          return lines
        }
        // 出す項目（マスタのitem）
        let targets = []
        if (categoryCode == '1') {
          // 月次目視点検は getRlsMsg の注記で出しているので含めない
          targets = ['toiletTimes', 'toiletPlace', 'meterTimes', 'meterPlace', 'photo']
        } else if (['3', '4'].includes(categoryCode)) {
          targets = ['toilet', 'toiletTimes', 'toiletPlace', 'specificTime', 'specificHours', 'freeHours', 'people']
        } else {
          return lines
        }

        const items = utils.getEstimateSubItemList(categoryCode, this.$store.getters.estimateSubItemList)
        for (let i = 0; i < items.length; i++) {
          const it = items[i]
          if (!targets.includes(it.item)) {
            continue
          }
          // 他の項目の選択によって見積り画面に出ていない項目は出さない
          if (!utils.judgementDisable(it, selectedValue)) {
            continue
          }
          const s = selectedValue[i]
          if (s === undefined || s === null || s === '') {
            continue
          }

          let name = it.name
          // 選択形式は選択肢の名前、入力形式は入力値（0 も出す）
          let value = it.itemCode ? it.itemCode[s] : s
          if (value === undefined) {
            continue
          }

          // 清掃時間は時間指定あり・なしで項目が分かれているので1つの名前にそろえる
          // （イレギュラー）は単価表の都合なので外す。手入力の時間があればそちら
          if (['specificHours', 'freeHours'].includes(it.item)) {
            name = '清掃時間'
            value = String(value).replace('（イレギュラー）', '')
            if (conf && conf.dispHours) {
              value = conf.dispHours + ' 時間'
            }
          }

          // 人数は手入力があればそちら。単位は「名」
          // ラウンドプラスの固定清掃は「3人」のように人付きで保存されているものがあるので外す
          if (it.item == 'people') {
            if (conf && conf.dispPeople) {
              value = conf.dispPeople
            }
            value = String(value).replace(/人/g, '').trim() + ' 名'
          }

          lines.push('　' + name + '：' + value)
        }
        return lines
      },

      /**
       * 見積りの詳細モーダルで年末年始対応を「なし」にしていれば、年末年始の行（日付を出す行と同じ位置）に出す文言を返す
       * 「あり」のときは受注の年末年始の日付の行で出している
       * 三井不動産・エム・エフは年末年始の行が必ず出るので「なし」は出さない
       * @param selectedValue 詳細モーダルで選んだ値
       * @param categoryCode カテゴリコード（マスタの親コード）
       */
      getNewYearNone(selectedValue, categoryCode) {
        if (this.isMitsui || !selectedValue || !selectedValue.length) {
          return ''
        }
        const items = utils.getEstimateSubItemList(categoryCode, this.$store.getters.estimateSubItemList)
        const idx = items.findIndex((it) => it.item == 'newYearHoliday')
        if (idx < 0 || selectedValue[idx] != '0') {
          return ''
        }
        return '　年末年始：なし'
      },

      /**
       * 毎週・第●曜日取得
       * @param o 対象受注データ
       */
      getWeekDetails(o) {
        const wd = o.weekDetail
        // 純粋なオブジェクト型の場合のみ
        if (wd && typeof wd === 'object' && !Array.isArray(wd)) {
          const res = []
          for (let i = 0; i < constants.WEEKS.length; i++) {
            const key = constants.WEEKS[i]
            if (wd[key]) {
              res.push(key + '：' + wd[key])
            }
          }
          if (res.length) {
            return '（' + res.join('、') + '）'
          }
        }
        return ''
      },

      /**
       * 年末年始勤務日生成
       * @param {*} val 対象年末年始配列
       */
      getNewYearDays(val) {
        const days = [30, 31, 1, 2, 3]
        const res = []
        for (let i = 0; i < days.length; i++) {
          const d = days[i]
          if (d === 30 && (this.isMitsui || val.includes(d))) {
            res.push('12/' + d)
          } else if (val.includes(d)) {
            if (d === 31) {
              res.push('12/' + d)
            } else {
              res.push('1/' + d)
            }
          }
        }
        return res.join('・')
      },

      /**
       * RLSプラス用の発注先
       * @param purchase 発注データ
       * @param temp テンプレート
       * @param byPur 発注先ごとのテンプレート
       * @param order 対象データ
       * @param estimate 見積りデータ
       * @param num 番号
       */
      setPlusTemplateDetail(purchase, temp, byPur, order, estimate, num) {
        // 行の内容を取得
        let rlsName = ''
        let normalName = ''
        let fixedName = ''
        let mitsui = ''
        if (this.isMitsui) {
          mitsui = '（三井不動産様は、12/30は勤務日です）'
        }

        estimate.subItemModalData.display.forEach(sub => {
          if (sub.name.indexOf('巡回') > -1) {
            rlsName = sub.name
          } else if (sub.name.indexOf('固定') > -1) {
            normalName = sub.name
          } else if (sub.name.indexOf('床面') > -1) {
            fixedName = sub.name
          }
        })
        // 作業曜日
        const w = this.getRlsPlusWeek(order)
        // 点灯確認などの文言
        const msg = this.getRlsMsg(estimate)
        // 定期清掃の床面通常洗浄を行う月
        let floor = ''
        // 見積りの詳細モーダルで選んだ作業内容のうち、上の行に無い項目
        // 巡回清掃はRLS、固定清掃は日常のマスタと選択肢を使っている
        const md = estimate.subItemModalData
        const rlsExtra = this.getSubItemLines(md.selectedRls, '1', null)
        const normalExtra = this.getSubItemLines(md.selectedNormal, '3', null)

        for (let i = 0; i < purchase.length; i++) {
          const p = purchase[i]
          const name = p.typeName.replace(/（クリーンプラス）/g, '').replace(/（ウォッシュプラス）/g, '').replace(/（ダブルプラス）/g, '')

          if (!byPur[p.supplier]) {
            byPur[p.supplier] = []
          }
          byPur[p.supplier].push(['●' + estimate.categoryName])

          let supplier = '　発注先　：' + p.supplier

          let price = '　発注額　：' + utils.numberToLocale(p.price) + '円'

          // 巡回清掃の場合
          if (name.indexOf('巡回') > -1) {
            // 作業曜日
            let week = ''
            if (order.workDays) {
              week = '　作業曜日：'
              // 曜日を並べ替え
              if (order.workDays && order.workDays.length) {
                week += order.workDays.join('・') + this.getWeekDetails(order)
              }
            }
            // 初回作業
            let start = '　初回作業：'
            if (order.startDate) {
              start += moment(order.startDate + ' 00:00:00').format('YYYY年M月D日')
            }

            // 年末年始（日付が無ければ、見積りで「なし」にしているときだけ「なし」）
            let ny = ''
            if (order.newYearHolidaysRls && (order.newYearHolidaysRls.length || this.isMitsui)) {
              ny = '　年末年始：' + this.getNewYearDays(order.newYearHolidaysRls) + mitsui
            } else {
              ny = this.getNewYearNone(md.selectedRls, '1')
            }

            byPur[p.supplier].push('●' + rlsName) // 項目名
            byPur[p.supplier].push(price)
            if (week) byPur[p.supplier].push(week)
            byPur[p.supplier].push(start)
            if (ny) byPur[p.supplier].push(ny)
            byPur[p.supplier].push(...rlsExtra)
            byPur[p.supplier].push(msg.val)
            byPur[p.supplier].push('')

            temp.push('　' + utils.toCircled(num) + '-' + (i + 1) + '：' + rlsName) // 項目名
            temp.push(supplier)
            temp.push(price)
            if (week) temp.push(week)
            temp.push(start)
            if (ny) temp.push(ny)
            temp.push(...rlsExtra)
            temp.push(msg.val)
            temp.push(msg.val2)
            temp.push('')

          // 固定清掃の場合
          } else if (name.indexOf('固定') > -1) {

            // 年末年始（日付が無ければ、見積りで「なし」にしているときだけ「なし」）
            let ny = ''
            if (order.newYearHolidays && (order.newYearHolidays.length || this.isMitsui)) {
              ny = '　年末年始：' + this.getNewYearDays(order.newYearHolidays) + mitsui
            } else {
              ny = this.getNewYearNone(md.selectedNormal, '3')
            }

            byPur[p.supplier].push('●' + normalName) // 項目名
            byPur[p.supplier].push(price)
            byPur[p.supplier].push(w.week2)
            byPur[p.supplier].push(w.time)
            if (ny) byPur[p.supplier].push(ny)
            byPur[p.supplier].push(...normalExtra)
            byPur[p.supplier].push('')

            temp.push('　' + utils.toCircled(num) + '-' + (i + 1) + '：' + normalName) // 項目名
            temp.push(supplier)
            temp.push(price)
            temp.push(w.week2)
            temp.push(w.time)
            if (ny) temp.push(ny)
            temp.push(...normalExtra)
            temp.push('※時間指定なしですが雇用指示登録に必要なため、作業曜日・作業予定時間のご返信をお願い致します。')
            temp.push('')

          // 定期清掃の場合
          } else {
            byPur[p.supplier].push('　' + fixedName) // 項目名
            temp.push('　' + utils.toCircled(num) + '-' + (i + 1) + '：' + fixedName) // 項目名

            temp.push(supplier)

            byPur[p.supplier].push(price)
            temp.push(price)

            floor = '　作業月　：'
            if (order.implementationMonth && order.implementationMonth.length) {
              // 通常と逆の場合
              if (order.implementationMonth[0].indexOf('逆') > -1) {
                floor += '床面通常洗浄➡偶数月、床面簡易洗浄➡奇数月'
                byPur[p.supplier].push(floor)
                byPur[p.supplier].push('※お客様ご希望により通常と逆になります。')

                temp.push(floor)
                temp.push('※お客様ご希望により通常と逆になります。')

              // 通常のまま
              } else {
                floor += '床面通常洗浄➡奇数月、床面簡易洗浄➡偶数月'
                byPur[p.supplier].push(floor)

                temp.push(floor)
              }
            } else {
              byPur[p.supplier].push(floor)
              temp.push(floor)
            }

            let first = '　初回作業：'
            if (order.firstWorkYear) {
              first += order.firstWorkYear
            }
            if (order.firstWorkMonth && order.firstWorkMonth.length) {
              first += order.firstWorkMonth[0]
            }
            byPur[p.supplier].push(first)
            temp.push(first)
            temp.push('※初回作業日がお決まりになりましたらお手数ですがご連絡頂きます様お願いいたします。')

            byPur[p.supplier].push('')
            temp.push('')
          }
        }
        return temp
      },

      /**
       * 日常・管理用の作業曜日を重複削除して取得
       * @param details 対象データ
       * @param temp テンプレート内容
       * @param byPur 発注先ごとのテンプレート
       */
      getWeek(details, temp, byPur) {
        let week = []
        for (let i = 0; i < details.length; i++) {
          const d = details[i]
          for (let j = 0; j < d.remarks.length; j++) {
            const r = d.remarks[j]
            if (r.workDays) {
              for (let k = 0; k < r.workDays.length; k++) {
                const w = r.workDays[k]
                if (!week.includes(w)) {
                  week.push(w)
                }
              }
            }
          }
        }
        // 取得した曜日を並べ替え
        week = this.sortItem(week, 'week')
        let week1 = '　回　数　：'
        let week2 = '　作業曜日：'
        if (week && week.length) {
          week1 += '週 ' + week.length + ' 回'
          week2 += '' + week.join('・')
        }
        temp.push(week1)
        temp.push(week2)
        byPur.push(week1)
        byPur.push(week2)
        return temp
      },

      /**
       * ラウンドプラス用の曜日、時間取得
       */
      getRlsPlusWeek(d) {
        let week = []
        let time = []

        for (let j = 0; j < d.remarks.length; j++) {
          const r = d.remarks[j]
          if (r.workDays) {
            for (let k = 0; k < r.workDays.length; k++) {
              const w = r.workDays[k]
              if (!week.includes(w)) {
                week.push(w)
              }
            }
            // 時間
            if (isDaysRemark(r)) {
              // 曜日ごとの形：時間帯が同じ曜日はまとめる
              for (const g of groupDaysByTime(r)) {
                if (g.startTime && g.endTime) {
                  time.push(g.startTime + '~' + g.endTime + '（' + g.weeks.join('・') + '）')
                }
              }
            } else if (r.startTime && r.endTime && r.startTime != ':' && r.endTime != ':') {
              let w = this.sortItem(r.workDays, 'week')
              time.push(r.startTime + '~' + r.endTime + '（' + w.join('・') + '）')
            }
          }
        }
        // 取得した曜日を並べ替え
        let week2 = '　作業曜日：'
        week = this.sortItem(week, 'week')
        if (week && week.length) {
          week2 += week.join('・')
        }
        return { week2, time: '　作業時間：' + time.join('、') }
      },

      /**
       * 曜日、もしくは月を並べ替え
       * @param arr 対象データ
       * @param type 曜日か月か
       */
      sortItem(arr, type) {
        let res = []
        let sort = constants.WEEKS
        if (type == 'month') {
          sort = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']
        }
        for (let i = 0; i < sort.length; i++) {
          const s = sort[i]
          for (let j = 0; j < arr.length; j++) {
            let a = arr[j]
            if (type == 'month') {
              a = a.replace('月', '')
            }
            if (a == s) {
              res.push(a)
            }
          }
        }
        return res
      },

      /**
       * データ保存時の処理
       */
      orderDataEmit() {
        this.$emit('toOrderData', this.order)
        // this.$emit('changeValidateContractDate', this.validateContractDate.result, this.validateContractDate.message)
        this.$emit('changeValidateContractEndDate', this.validateContractEndDate.result, this.validateContractEndDate.message)
        this.$emit('changeValidateClassification', this.validateClassification.result, this.validateClassification.message)

      },

      /**
       * 契約日変更イベント
       */
      changeContractDate() {
        this.$emit('changeValidateContractEndDate', this.validateContractEndDate.result, this.validateContractEndDate.message)
        // 区分によって契約終了日の初期値を入れる
        this.setContractEndDate()

        // タイトル自動設定
        this.setTitle()
      },

      /**
       * 区分によって契約終了日の初期値を入れる
       */
      setContractEndDate() {
        // スポットの場合は、1か月後
        if (this.order.classification && this.order.classification.length && this.order.classification[0] == '3') {
          this.order.contractEndDate = moment(this.order.contractDate).add(1, 'M').subtract(1, 'd').format('YYYY-MM-DD')
        } else {
          this.order.contractEndDate = moment(this.order.contractDate).add(1, 'Y').subtract(1, 'd').format('YYYY-MM-DD')
        }
        this.changeContractEndDate()

         // タイトル自動設定
        this.setTitle()
      },

      /**
       * タイトル設定
       */
      setTitle() {
        if (!this.initialized) return   // イニシャライズ時は処理しない

        let kakko = ''
        // 契約日
        if (this.order.contractDate) kakko = moment(this.order.contractDate).format('YYYY年M月')
        // 受注区分
        if (this.order.classification.length > 0) {
          const select = this.selectItemClassification.find( item => item.value == this.order.classification[0])
          kakko += select.text
        }
        // 括弧
        if (kakko) kakko = '【' + kakko + '】'

        // 物件名
        let title = kakko + this.estimateData.buildingName

        // 受注処理
        if (title) title += ' '
        title += '受注処理'

        this.mainData.inquiry_title = title
      },

      changeContractEndDate() {
        this.$emit('changeValidateContractEndDate', this.validateContractEndDate.result, this.validateContractEndDate.message)
      },

      /**
       * 初回作業月変更イベント
       * @param value 値
       * @param i インデックス
       * @param tar 対象プロパティー
       */
      changeFirstWorkMonth(value, i, tar) {
        // 単位から数字を削除
        const unit = this.order[tar][i].unit.replace(/[0-9]/g, '')
        // 単位が「回/年」（「回/2年」なども）ならば自動で作業月を判定
        if (value && value.length && unit == '回/年' && (this.order[tar][i].implementationMonth)) {
          this.order[tar][i].implementationMonth = this.workMonthAutoInput(value, this.order[tar][i].count, this.order[tar][i].implementationMonth)
        }
        this.$set(this.order[tar][i], 'firstWorkMonth', value)
      },

      /**
       * 初回作業月変更イベント（details内の初回作業月の場合）
       * @param value 値
       * @param i インデックス
       * @param tar 対象プロパティー
       */
      changeFirstWorkMonthDetails(value, i, tar, order) {
        // 単位から数字を削除
        let unit = ''
        if (tar[i].unit) {
          unit = tar[i].unit.replace(/[0-9]/g, '')
        } else if (order.unit) {
          unit = order.unit.replace(/[0-9]/g, '')
        }
        // 単位が「回/年」（「回/2年」なども）ならば自動で作業月を判定
        if (value && value.length && unit == '回/年' && tar[i].implementationMonth) {
          let count = '0'
          if (tar[i].count) {
            count = tar[i].count
          } else if (order.count) {
            count = order.count
          }
          tar[i].implementationMonth = this.workMonthAutoInput(value, count, tar[i].implementationMonth)
        }
        this.$set(tar[i], 'firstWorkMonth', value)
      },


      /**
       * 区分変更イベント
       */
      changeClassification() {
        this.$emit('changeValidateClassification', this.validateClassification.result, this.validateClassification.message)
        // 区分によって契約終了日の初期値を入れる
        this.setContractEndDate()

        if (this.order.classification.length && this.order.classification[0] != '') {
          this.classification = this.order.classification[0]
        }
      },

      /**
       * 作業内容コードマスタデータを取得
       */
      async getWorkCode() {
        this.workCodeList = [{ name: '', details: [{ name: '', code: '' }] }]
        let result = await estimateManager.getWorkCode(this)
        if (result && result.length) {
          // コード順に並べ替え
          let sortList = []
          sortList = result.sort(function(a, b) {
            return (Number(a.code) > Number(b.code)) ? 1 : -1;
          });
          result = utils.clone(sortList)

          let category = []
          // 大項目をリスト化
          for (let i = 0; i < result.length; i++) {
            const c = result[i].category
            if (!category.includes(c)) {
              category.push(c)
            }
          }

          this.workCodeList = []
          // データの形を生成
          for (let j = 0; j < category.length; j++) {
            const ca = category[j]
            let row = {}
            row.name = ca
            for (let k = 0; k < result.length; k++) {
              const r = result[k]
              if (ca == r.category) {
                if (!row.details) {
                  row.details = []
                }
                row.details.push({ name: r.detail, code: r.code })
              }
            }
            this.workCodeList.push(row)
          }
        }
      },

      /**
       * MRSのゴミ搬出回数の表示文言（配信用テンプレートのゴミ出しと同じ）
       * @param val 見積りの詳細モーダルで選んだ値
       */
      formatMrsTrashCount(val) {
        if (val === undefined || val === null || val === '') {
          return ''
        }
        if (val == '0') {
          return 'なし'
        }
        return `週 ${val} 回`
      },

      /**
       * MRSのゴミ搬出回数を取得
       * 受注の行に保存していればそれ、無ければ（この項目を付ける前に保存した受注）見積りの詳細モーダルの値から
       * @param o 受注の行
       */
      getMrsTrashCount(o) {
        if (o.trashCount) {
          return o.trashCount
        }
        if (!this.estimateData || !this.estimateData.details) {
          return ''
        }
        const e = this.estimateData.details.find((d) => d.categoryCode == '29' && d.groupName == o.groupName)
        if (!e || !e.subItemModalData || !e.subItemModalData.selectedValue) {
          return ''
        }
        return this.formatMrsTrashCount(e.subItemModalData.selectedValue[2])
      },

      /**
       * 作業内容コード初期値取得
       */
      getInitWorkCode(val, categoryCode) {
        // MRSの場合
        if (categoryCode == '29') {
          return {
            category: 'RLS',
            detail: '巡回清掃',
            code: '0001150'
          }
        } else {
          for (let i = 0; i < this.workCodeList.length; i++) {
            let name = this.workCodeList[i].name
              if (name == 'RLS') {
                name = 'ラウンド'
              }
              if (name && val.indexOf(name) > -1) {
                if (name == 'ラウンド') {
                  name = 'RLS'
                }
                return { category: name }
              }
          }
          // 該当なしの場合は空文字
          return {}
        }
      },

      /**
       * 作業曜日クリック
       */
      clickWorkDays(val, tar) {
        // 毎週などのデータ
        if (!tar.weekDetail) {
          tar.weekDetail = {}
        }

        if (tar.workDays.includes(val)) {
          // 同じ曜日を削除
          tar.workDays = tar.workDays.filter((a) => {
            return a != val
          })
          // 毎週などのデータを削除
          delete tar.weekDetail[val]

        } else {
          // クリックされた曜日を追加
          tar.workDays.push(val)

          // ソート
          const sort = constants.WEEKS
          const sorted = tar.workDays.sort((a, b) => {
            return sort.indexOf(a) - sort.indexOf(b)
          })
          tar.workDays = sorted

          // 月1、月2ではない場合
          if (!tar.count2 || (tar.count2 && !tar.count2[0].includes('月'))) {
            tar.weekDetail[val] = ['毎週']
          }
        }
        this.reload++
      },

      /**
       * 作業開始メモ更新
       */
      async changeStartMemo() {
        if (this.order.startMemo) {
          this.startMemoBgColor = false
        }
        // サブタスク画面のみ
        if (this.isDisabled) {
          this.updateStartMemo = true
          const data = {
            startMemo: this.order.startMemo,
          }

          await orderManager.upDateOneForMain(this, this.order._id, data)

          this.updateStartMemo = false
        }
      },

      /**
       * 作業内容モーダルopen
       * @param tar 対象データ
       */
      openWorkCode(tar) {
        if (this.isDisabled || this.referenceMode) {
          return
        }
        this.workCode.target = tar.workCode
        this.workCode.original = tar
        this.workCodeModalShow = true
      },

      /**
       * 作業内容モーダルcolse
       */
      closeWorkCode(res) {
        this.workCode.original.workCode = res
        this.workCode = {}
        this.workCodeModalShow = false
      },

      /**
      * スクロールでの数字変更不可
      */
      inputFocus(e) {
        utils.inputFocus(e)
      },

      /**
       * 背景色セット
       */
      setStartMemoBgColor() {
        this.startMemoBgColor = true
      },

      /**
       * 作業開始メモへスクロール
       */
      toScrollStartMemo() {
        const el = this.$refs.startMemo
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })
        }
      }
    }
  }
</script>

<style scoped>
.button-w-sm >>> button[type=button] {
  width: 19.5% !important;
}

.button-w-sm2 >>> button[type=button] {
  width: 14% !important;
}

.button-w-sm3 >>> button[type=button] {
  width: 16.2% !important;
}

#sub-label h3 {
  color: rgb(9, 9, 198);
}

.multiselect >>> .multiselect__tags {
  padding-right: 22px !important;
}

.multiselect >>> .multiselect__select {
  padding-right: 4px !important;
}

.field {
  field-sizing: content !important;
}
</style>